// import React, { forwardRef } from "react";
// import "./ServitorInvoiceTemplate.css";

// const ServitorInvoiceTemplate = forwardRef(({ order }, ref) => {
//   const serviceName = order.Service
//     ? order.Service.services_name
//     : order.service_name || "Unknown";

//   const serviceFields = {
//     "Home Cleaning": [
//       { key: "bed", label: "Bedroom" },
//       { key: "kitchen", label: "Kitchen" },
//       { key: "dra_din", label: "Drawing-Dining" },
//       { key: "bath", label: "Bathroom" },
//       { key: "balcony", label: "Balcony Cleaning" },
//       { key: "window_grill", label: "Window & Grill Cleaning" },
//       { key: "stairs_and_railing", label: "Stairs & Railing Cleaning" },
//       { key: "furniture_cleaning", label: "Furniture Cleaning" },
//       { key: "cloth", label: "Cloths" },
//       { key: "dish", label: "Dishes" },
//       { key: "carpet_cleaning", label: "Carpet Cleaning" },
//     ],
//     Electrician: [
//       { key: "Fan_in_un", label: "Fan Install" },
//       { key: "Light_in_un", label: "Light Install" },
//       { key: "Fan_repair", label: "Fan Repair" },
//       { key: "Light_repair", label: "Light Repair" },

//       { key: "Doorbell_setup", label: "Doorbell setup" },
//       { key: "Exhaust_fan_setup", label: "Exhaust fan setup" },
//       { key: "Exhaust_fan_repair", label: "Exhaust fan repair" },
//       { key: "Drill_wall_holes", label: "Drill wall holes" },

//       { key: "Switch_repair", label: "Switch Repair" },
//       { key: "MCB_service", label: "MCB Service" },
//       { key: "MDB_service", label: "MDB Service" },
//       { key: "Fan_regulator_in_un", label: "Regulator Install" },
//       { key: "Fan_regulator_repair", label: "Regulator Repair" },
//       { key: "Socket_in_un", label: "Socket Install" },
//       { key: "Socket_repair", label: "Socket Repair" },
//       { key: "Circuit_breaker_repair", label: "Breaker Repair" },
//       { key: "New_wiring_point", label: "New Wiring Point" },
//       { key: "Coil_repair",   label: "Fan Coil Repair" },
//       // { key: "Full_wiring", label: "Full Wiring", format: (v) => (v ? "Yes" : "No") },
//       { key: "Electrical_checkup", label: "Electrical Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     Plumber: [
//       { key: "Toilet_in", label: "Toilet Install" },
//       { key: "Faucet_in", label: "Faucet Install" },
//       { key: "Sink_in", label: "Sink Install" },
//       { key: "Dishwasher_in", label: "Dishwasher Install" },
//       { key: "Leak_repair", label: "Leak Repair" },
//       { key: "Faucet_repair", label: "Faucet Repair" },
//       { key: "Toilet_repair", label: "Toilet Repair" },
//       { key: "Shower_repair", label: "Shower Repair" },
//       { key: "Drain_cleaning", label: "Drain Cleaning" },
//       { key: "pipe_cleaning", label: "Pipe Cleaning" },
//       { key: "tank_cleaning", label: "Tank Cleaning" },
//       { key: "geyser_setup", label: "Geyser Install" },
//       { key: "geyser_repair", label: "Geyser Repair" },
//       { key: "issue_checkup", label: "Issue Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     "Gas Chula": [
//       { key: "chulaCylinderType", label: "Cylinder Type" },
//       { key: "NewchulaSetup",     label: "New Chula Setup" },
//       { key: "chulaSetup",        label: "Chula Setup" },
//       { key: "burnerSetup",       label: "Burner Setup" },
//       { key: "burnerCleaning",    label: "Burner Cleaning" },
//       { key: "nozzleReplacement", label: "Nozzle Replacement" },
//       {
//         key:    "checkIssues",
//         label:  "Check Issues",
//         format: v => v ? "Yes" : "No"
//       },
//     ],

//     "AC Service": [
//       { key: "acType",        label: "AC Type" },            
//       { key: "acTon",         label: "AC Ton" },             
//       { key: "new_setup",     label: "New Setup" },
//       { key: "installation",  label: "Installation" },
//       { key: "uninstallation",label: "Uninstallation" },
//       { key: "gas_refill",    label: "Gas Refill" },
//       { key: "cleaning",      label: "Cleaning" },
//       { key: "issue_checkup", label: "Issue Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],

//     Filter: [
//     { key: "filter_type", label: "Filter Type" },                        
//     { key: "new_filter_setup", label: "New Filter Setup" },         
//     { key: "installation_filter", label: "Filter Installation" },   
//     { key: "uninstallation_filter", label: "Filter Uninstallation" },
//     { key: "kit_replacement", label: "Kit Replacement" },           
//     { key: "pipe_leak_or_replace", label: "Pipe Leak / Replace" },  
//     { key: "full_servicing", label: "Full Servicing" },             
//     { key: "check_up", label: "Issue Checkup", format: v => (v ? "Yes" : "No") },
//     ],

//     "Tutor Service": [
//     { key: "subject",               label: "Subject" },
//     { key: "classLevel",            label: "Class/Level" },
//     { key: "medium",                label: "Medium" },
//     // hide if it's "Any"
//     { key: "preferredTutorGender",  label: "Preferred Tutor Gender", format: v => (String(v).toLowerCase() === "any" ? null : v) },
//     { key: "daysPerWeek",           label: "Days per Week",  format: v => `${v} day${Number(v) > 1 ? "s" : ""}/week` },
//     { key: "hoursPerDay",           label: "Hours per Day",  format: v => `${v} hour${Number(v) > 1 ? "s" : ""}/day` },
//     { key: "priorityInstitution",   label: "Priority Institution" },
//     { key: "salary",                label: "Salary",         format: v => `৳${v}` }
//     ],
//   };

//   const fields = serviceFields[order.service_name] || [];

//   // const services = fields
//   //   .map(({ key, label, format }) => {
//   //     const raw = order[key];
//   //     if (raw === undefined || raw === null) return null;

//   //     const quantity = format ? format(raw) : raw;

//   //     if (typeof quantity === "number" && quantity > 0) {
//   //       return { label, quantity };
//   //     }
//   //     if (
//   //       typeof quantity === "string" &&
//   //       quantity.toLowerCase() === "yes"
//   //     ) {
//   //       return { label, quantity };
//   //     }
//   //     return null;
//   //   })
//   //   .filter(Boolean);


//   const services = fields
//    .map(({ key, label, format }) => {
//      const raw = order[key];
//      if (raw === undefined || raw === null) return null;

//      // decide inclusion based on RAW value
//      let include =
//        (typeof raw === "number"  && raw > 0) ||
//        (typeof raw === "boolean" && raw)     ||
//        (typeof raw === "string"  && raw.trim() && !["no","n/a","any"].includes(raw.trim().toLowerCase()));
//      if (!include) return null;

//      const v = format ? format(raw) : raw;
//      if (v === null || v === undefined || String(v).trim() === "") return null; // respect “hide” from format
//      return { label, quantity: v };
//    })
//    .filter(Boolean);

//   const chunkedServices = [];
//   for (let i = 0; i < services.length; i += 4) {
//     chunkedServices.push(services.slice(i, i + 4));
//   }

//   return (
//     <div className="ServitorReceipt-container" ref={ref}>
//       <div className="ServitorReceipt-header">
//         <div className="ServitorReceipt-header-top">
//           <div className="ServitorReceipt-logo">HelpNao</div>
//           <div className="ServitorReceipt-number">
//             <h3>Servitor Receipt</h3>
//             <p>Order #{order.order_number}</p>
//           </div>
//         </div>

//         <div className="ServitorReceipt-order-info">
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Order Date</span>
//             <span className="ServitorReceipt-value">
//               {new Date(order.created_at).toLocaleDateString("en-US", {
//                 month: "long",
//                 day: "numeric",
//                 year: "numeric",
//               })}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Date</span>
//             <span className="ServitorReceipt-value">
//               {order.date
//                 ? new Date(order.date).toLocaleDateString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })
//                 : "TBD"}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Time</span>
//             <span className="ServitorReceipt-value">{order.time}</span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Status</span>
//             <span className="ServitorReceipt-status-badge">{order.status}</span>
//           </div>
//         </div>
//       </div>

//       <div className="ServitorReceipt-content">
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Service Details</h2>
//           <div className="ServitorReceipt-details-row">
//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Customer Information</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.User
//                     ? `${order.User.FirstName} ${order.User.LastName}`
//                     : "Unknown"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Mobile</span>
//                 <span className="ServitorReceipt-value">
//                   {order.User ? `0${order.User.mobile}` : "Unknown"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">City</span>
//                 <span className="ServitorReceipt-value">
//                   {order.usercity || order.City}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.useraddress || order.Address}
//                 </span>
//               </div>
//             </div>

//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Service Provider</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Mobile</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor
//                     ? `0${order.Servitor.mobile}`
//                     : "N/A"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">NID</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.NID || "N/A" : "N/A"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor
//                     ? order.Servitor.city || "No city"
//                     : "N/A"}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Services Provided</h2>
//           <div className="ServitorReceipt-service-section">
//             <div className="ServitorReceipt-service-header">{serviceName}</div>
//             <div className="ServitorReceipt-service-table">
//               {chunkedServices.map((row, rowIdx) => (
//                 <div className="ServitorReceipt-service-row" key={rowIdx}>
//                   {row.map((svc, idx) => (
//                     <div className="ServitorReceipt-service-card" key={idx}>
//                       <div className="ServitorReceipt-service-name">{svc.label}</div>
//                       <div className="ServitorReceipt-service-quantity">
//                         {svc.quantity}{" "}
//                         {typeof svc.quantity === "number" 
//                           ? svc.quantity === 1 
//                             ? "unit" 
//                             : "units"
//                           : ""}
//                       </div>
//                     </div>
//                   ))}
//                   {Array.from({ length: 4 - row.length }).map((_, idx) => (
//                     <div key={`empty-${idx}`} className="ServitorReceipt-service-card-empty"></div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="ServitorReceipt-total-section">
//           <div className="ServitorReceipt-total-label">Total Amount</div>
//           <div className="ServitorReceipt-total-amount">৳{order.price}</div>
//         </div>
//       </div>

//       <div className="ServitorReceipt-footer">
//         <div className="ServitorReceipt-footer-title">Thank you for serving with HelpNao!</div>
//         <div className="ServitorReceipt-footer-text">
//           {/* We value your dedication to our customers */}
//           Your dedication drives our success
//         </div>
//         <div className="ServitorReceipt-contact-info">
//           For support: support@HelpNao.com | +880123456789
//         </div>
//       </div>
//     </div>
//   );
// });

// export default ServitorInvoiceTemplate;











// ***** New Updated (16-oct-2025) ***** //
// import React, { forwardRef } from "react";
// import "./ServitorInvoiceTemplate.css";

// /* ---- per-service unit prices (tk) ---- */
// const PRICE_TABLE = {
//   "Home Cleaning": {
//     // chargeable qty is (value - 1) for these three “core” rooms
//     bed: 30,
//     kitchen: 20,
//     dra_din: 40,

//     bath: 50,
//     cloth: 10,
//     dish: 10,
//     balcony: 30,
//     window_grill: 40,
//     furniture_cleaning: 60,
//     stairs_and_railing: 40,
//     carpet_cleaning: 50,
//   },

//   Electrician: {
//     Fan_in_un: 200,
//     Light_in_un: 80,
//     Fan_repair: 150,
//     Light_repair: 70,
//     Doorbell_setup: 120,
//     Exhaust_fan_setup: 200,
//     Exhaust_fan_repair: 150,
//     Drill_wall_holes: 50,
//     Switch_repair: 150,
//     MCB_service: 100,
//     MDB_service: 200,
//     Fan_regulator_in_un: 120,
//     Fan_regulator_repair: 100,
//     Socket_in_un: 150,
//     Socket_repair: 100,
//     Circuit_breaker_repair: 250,
//     New_wiring_point: 350,
//     Coil_repair: 800,
//     Electrical_checkup: 100, // boolean -> flat
//   },

//   Plumber: {
//     Toilet_in: 250,
//     Faucet_in: 100,
//     Sink_in: 200,
//     Dishwasher_in: 200,
//     Leak_repair: 500,
//     Faucet_repair: 100,
//     Toilet_repair: 100,
//     Shower_repair: 100,
//     Drain_cleaning: 150,
//     pipe_cleaning: 300,
//     tank_cleaning: 800,
//     geyser_setup: 1200,
//     geyser_repair: 800,
//     issue_checkup: 250, // boolean -> flat
//   },

//   "Gas Chula": {
//     // descriptor (no price): chulaCylinderType
//     NewchulaSetup: 500,
//     chulaSetup: 300,
//     burnerSetup: 200,
//     burnerCleaning: 150,
//     nozzleReplacement: 120,
//     checkIssues: 100, // boolean -> flat
//   },

//   "AC Service": {
//     // descriptors (no price): acType, acTon
//     new_setup: 1500,
//     installation: 1200,
//     uninstallation: 800,
//     gas_refill: 1200,
//     cleaning: 600,
//     issue_checkup: 200, // boolean -> flat
//   },

//   Filter: {
//     // descriptor (no price): filter_type
//     new_filter_setup: 500,
//     installation_filter: 300,
//     uninstallation_filter: 200,
//     kit_replacement: 150,
//     pipe_leak_or_replace: 120,
//     full_servicing: 400,
//     check_up: 100, // boolean -> flat
//   },

//   "Tutor Service": {
//     // no per-line prices & no booking fee
//   },
// };

// /* base/booking fee per service */
// const BOOKING_FEE = {
//   "Home Cleaning": 100,
//   Electrician: 100,
//   Plumber: 300,
//   "Gas Chula": 100,
//   "AC Service": 100,
//   Filter: 100,
//   "Tutor Service": 0,
// };

// const isTruthy = (v) =>
//   (typeof v === "number" && v > 0) ||
//   (typeof v === "boolean" && v) ||
//   (typeof v === "string" &&
//     v.trim() &&
//     !["no", "n/a", "any"].includes(v.trim().toLowerCase()));

// const money = (n) => `৳${Number(n || 0).toLocaleString("en-BD")}`;

// const ServitorInvoiceTemplate = forwardRef(({ order }, ref) => {
//   const serviceName = order.Service
//     ? order.Service.services_name
//     : order.service_name || "Unknown";

//   /* ---- fields (same as your original) ---- */
//   const serviceFields = {
//     "Home Cleaning": [
//       { key: "bed", label: "Bedroom" },
//       { key: "kitchen", label: "Kitchen" },
//       { key: "dra_din", label: "Drawing-Dining" },
//       { key: "bath", label: "Bathroom" },
//       { key: "balcony", label: "Balcony Cleaning" },
//       { key: "window_grill", label: "Window & Grill Cleaning" },
//       { key: "stairs_and_railing", label: "Stairs & Railing Cleaning" },
//       { key: "furniture_cleaning", label: "Furniture Cleaning" },
//       { key: "cloth", label: "Cloths" },
//       { key: "dish", label: "Dishes" },
//       { key: "carpet_cleaning", label: "Carpet Cleaning" },
//     ],
//     Electrician: [
//       { key: "Fan_in_un", label: "Fan Install" },
//       { key: "Light_in_un", label: "Light Install" },
//       { key: "Fan_repair", label: "Fan Repair" },
//       { key: "Light_repair", label: "Light Repair" },

//       { key: "Doorbell_setup", label: "Doorbell setup" },
//       { key: "Exhaust_fan_setup", label: "Exhaust fan setup" },
//       { key: "Exhaust_fan_repair", label: "Exhaust fan repair" },
//       { key: "Drill_wall_holes", label: "Drill wall holes" },

//       { key: "Switch_repair", label: "Switch Repair" },
//       { key: "MCB_service", label: "MCB Service" },
//       { key: "MDB_service", label: "MDB Service" },
//       { key: "Fan_regulator_in_un", label: "Regulator Install" },
//       { key: "Fan_regulator_repair", label: "Regulator Repair" },
//       { key: "Socket_in_un", label: "Socket Install" },
//       { key: "Socket_repair", label: "Socket Repair" },
//       { key: "Circuit_breaker_repair", label: "Breaker Repair" },
//       { key: "New_wiring_point", label: "New Wiring Point" },
//       { key: "Coil_repair", label: "Fan Coil Repair" },
//       { key: "Electrical_checkup", label: "Electrical Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     Plumber: [
//       { key: "Toilet_in", label: "Toilet Install" },
//       { key: "Faucet_in", label: "Faucet Install" },
//       { key: "Sink_in", label: "Sink Install" },
//       { key: "Dishwasher_in", label: "Dishwasher Install" },
//       { key: "Leak_repair", label: "Leak Repair" },
//       { key: "Faucet_repair", label: "Faucet Repair" },
//       { key: "Toilet_repair", label: "Toilet Repair" },
//       { key: "Shower_repair", label: "Shower Repair" },
//       { key: "Drain_cleaning", label: "Drain Cleaning" },
//       { key: "pipe_cleaning", label: "Pipe Cleaning" },
//       { key: "tank_cleaning", label: "Tank Cleaning" },
//       { key: "geyser_setup", label: "Geyser Install" },
//       { key: "geyser_repair", label: "Geyser Repair" },
//       { key: "issue_checkup", label: "Issue Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     "Gas Chula": [
//       { key: "chulaCylinderType", label: "Cylinder Type" },
//       { key: "NewchulaSetup", label: "New Chula Setup" },
//       { key: "chulaSetup", label: "Chula Setup" },
//       { key: "burnerSetup", label: "Burner Setup" },
//       { key: "burnerCleaning", label: "Burner Cleaning" },
//       { key: "nozzleReplacement", label: "Nozzle Replacement" },
//       { key: "checkIssues", label: "Check Issues", format: (v) => (v ? "Yes" : "No") },
//     ],
//     "AC Service": [
//       { key: "acType", label: "AC Type" },
//       { key: "acTon", label: "AC Ton" },
//       { key: "new_setup", label: "New Setup" },
//       { key: "installation", label: "Installation" },
//       { key: "uninstallation", label: "Uninstallation" },
//       { key: "gas_refill", label: "Gas Refill" },
//       { key: "cleaning", label: "Cleaning" },
//       { key: "issue_checkup", label: "Issue Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     Filter: [
//       { key: "filter_type", label: "Filter Type" },
//       { key: "new_filter_setup", label: "New Filter Setup" },
//       { key: "installation_filter", label: "Filter Installation" },
//       { key: "uninstallation_filter", label: "Filter Uninstallation" },
//       { key: "kit_replacement", label: "Kit Replacement" },
//       { key: "pipe_leak_or_replace", label: "Pipe Leak / Replace" },
//       { key: "full_servicing", label: "Full Servicing" },
//       { key: "check_up", label: "Issue Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     "Tutor Service": [
//       { key: "subject", label: "Subject" },
//       { key: "classLevel", label: "Class/Level" },
//       { key: "medium", label: "Medium" },
//       { key: "preferredTutorGender", label: "Preferred Tutor Gender", format: (v) => (String(v).toLowerCase() === "any" ? null : v) },
//       { key: "daysPerWeek", label: "Days per Week", format: (v) => `${v} day${Number(v) > 1 ? "s" : ""}/week` },
//       { key: "hoursPerDay", label: "Hours per Day", format: (v) => `${v} hour${Number(v) > 1 ? "s" : ""}/day` },
//       { key: "priorityInstitution", label: "Priority Institution" },
//       { key: "salary", label: "Salary", format: (v) => `৳${v}` },
//     ],
//   };

//   const fields = serviceFields[order.service_name] || [];
//   const priceMap = PRICE_TABLE[order.service_name] || {};
//   const bookingFee = BOOKING_FEE[order.service_name] ?? 0;
//   const isTutor = order.service_name === "Tutor Service";

//   // Build priced lines + descriptors
//   const lines = fields
//     .map(({ key, label, format }) => {
//       const raw = order[key];
//       if (raw === undefined || raw === null) return null;

//       const unitPrice = priceMap[key];
//       const display = format ? format(raw) : raw;

//       // Home Cleaning: first unit of these three is included
//       let chargeableQty = raw;
//       if (
//         order.service_name === "Home Cleaning" &&
//         (key === "bed" || key === "kitchen" || key === "dra_din")
//       ) {
//         chargeableQty = Math.max(0, Number(raw) - 1);
//       }

//       // boolean + priced -> flat fee
//       if (typeof raw === "boolean" && unitPrice) {
//         return {
//           key,
//           label,
//           qty: 1,
//           unitPrice,
//           lineTotal: unitPrice,
//           priceText: `1 × ${unitPrice}`,
//           descriptor: false,
//         };
//       }

//       // numeric + priced
//       if (typeof raw === "number" && unitPrice) {
//         if (chargeableQty <= 0) return null;
//         return {
//           key,
//           label,
//           qty: chargeableQty,
//           unitPrice,
//           lineTotal: chargeableQty * unitPrice,
//           priceText:
//             order.service_name === "Home Cleaning" &&
//             (key === "bed" || key === "kitchen" || key === "dra_din")
//               ? `${chargeableQty} × ${unitPrice} (1st included)`
//               : `${chargeableQty} × ${unitPrice}`,
//           descriptor: false,
//         };
//       }

//       // descriptors (no price)
//       if (isTruthy(raw) && unitPrice === undefined) {
//         return {
//           key,
//           label,
//           descriptor: true,
//           descriptorValue: display,
//         };
//       }

//       return null;
//     })
//     .filter(Boolean);

//   const subTotal = lines
//     .filter((l) => !l.descriptor)
//     .reduce((acc, l) => acc + l.lineTotal, 0);

//   // Tutor: no booking fee, total comes from order.price if provided; else subtotal
//   const totalAmount = isTutor ? (order.price ?? subTotal) : subTotal + bookingFee;

//   // 4-column grid chunk
//   const chunkedServices = [];
//   for (let i = 0; i < lines.length; i += 4) {
//     chunkedServices.push(lines.slice(i, i + 4));
//   }

//   return (
//     <div className="ServitorReceipt-container" ref={ref}>
//       {/* HEADER */}
//       <div className="ServitorReceipt-header">
//         <div className="ServitorReceipt-header-top">
//           <div className="ServitorReceipt-logo">HelpNao</div>
//           <div className="ServitorReceipt-number">
//             <h3>Servitor Receipt</h3>
//             <p>Order #{order.order_number}</p>
//           </div>
//         </div>

//         <div className="ServitorReceipt-order-info">
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Order Date</span>
//             <span className="ServitorReceipt-value">
//               {new Date(order.created_at).toLocaleDateString("en-US", {
//                 month: "long",
//                 day: "numeric",
//                 year: "numeric",
//               })}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Date</span>
//             <span className="ServitorReceipt-value">
//               {order.date
//                 ? new Date(order.date).toLocaleDateString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })
//                 : "TBD"}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Time</span>
//             <span className="ServitorReceipt-value">{order.time}</span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Status</span>
//             <span className="ServitorReceipt-status-badge">{order.status}</span>
//           </div>
//         </div>
//       </div>

//       {/* CONTENT */}
//       <div className="ServitorReceipt-content">
//         {/* Customer & Provider */}
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Service Details</h2>
//           <div className="ServitorReceipt-details-row">
//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Customer Information</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.User
//                     ? `${order.User.FirstName} ${order.User.LastName}`
//                     : "Unknown"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Location</span>
//                 <span className="ServitorReceipt-value">
//                   {(order.usercity || order.City) ?? "N/A"}
//                   {order.userarea || order.Area ? `, ${order.userarea || order.Area}` : ""}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.useraddress || order.Address || "N/A"}
//                 </span>
//               </div>
//             </div>

//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Service Provider</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Location</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.city || "N/A" : "N/A"}
//                   {order.Servitor && order.Servitor.area ? `, ${order.Servitor.area}` : ""}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.Address || "No Address" : "N/A"}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Services Provided */}
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Services Provided</h2>
//           <div className="ServitorReceipt-service-section">
//             <div className="ServitorReceipt-service-header">{serviceName}</div>
//             <div className="ServitorReceipt-service-table">
//               {chunkedServices.map((row, rowIdx) => (
//                 <div className="ServitorReceipt-service-row" key={rowIdx}>
//                   {row.map((svc, idx) => (
//                     <div className="ServitorReceipt-service-card" key={idx}>
//                       <div className="ServitorReceipt-service-name">{svc.label}</div>

//                       {svc.descriptor ? (
//                         <div className="ServitorReceipt-service-descriptor">
//                           {String(svc.descriptorValue)}
//                         </div>
//                       ) : (
//                         <div className="ServitorReceipt-service-quantity">
//                           {svc.priceText} = <strong>{money(svc.lineTotal)}</strong>
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                   {Array.from({ length: 4 - row.length }).map((_, idx) => (
//                     <div key={`empty-${idx}`} className="ServitorReceipt-service-card-empty"></div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Subtotal + Booking Fee (except Tutor) */}
//         {!isTutor && (
//           <div className="ServitorReceipt-subtotals">
//             <div className="ServitorReceipt-totals-row">
//               <span className="ServitorReceipt-total-label">Subtotal</span>
//               <span className="ServitorReceipt-total-value">{money(subTotal)}</span>
//             </div>
//             <div className="ServitorReceipt-totals-row">
//               <span className="ServitorReceipt-total-label">Booking Fee</span>
//               <span className="ServitorReceipt-total-value">{money(bookingFee)}</span>
//             </div>
//           </div>
//         )}

//         {/* Final Total */}
//         <div className="ServitorReceipt-total-section">
//           <div className="ServitorReceipt-total-label">Total Amount</div>
//           <div className="ServitorReceipt-total-amount">{money(totalAmount)}</div>
//         </div>
//       </div>

//       {/* FOOTER */}
//       <div className="ServitorReceipt-footer">
//         <div className="ServitorReceipt-footer-title">Thank you for serving with HelpNao!</div>
//         <div className="ServitorReceipt-footer-text">
//           Your dedication drives our success
//         </div>
//         <div className="ServitorReceipt-contact-info">
//           For support: support@HelpNao.com | +880123456789
//         </div>
//       </div>
//     </div>
//   );
// });

// export default ServitorInvoiceTemplate;






// ***** Updated with discount value (18-Oct-2025) ***** //
// ***** New Updated (with discount excluded for Tutor) ***** //
// import React, { forwardRef } from "react";
// import "./ServitorInvoiceTemplate.css";

// /* ---- per-service unit prices (tk) ---- */
// const PRICE_TABLE = {
//   "Home Cleaning": {
//     bed: 30,
//     kitchen: 20,
//     dra_din: 40,

//     bath: 50,
//     cloth: 10,
//     dish: 10,
//     balcony: 30,
//     window_grill: 40,
//     furniture_cleaning: 60,
//     stairs_and_railing: 40,
//     carpet_cleaning: 50,
//   },

//   Electrician: {
//     Fan_in_un: 200,
//     Light_in_un: 80,
//     Fan_repair: 150,
//     Light_repair: 70,
//     Doorbell_setup: 120,
//     Exhaust_fan_setup: 200,
//     Exhaust_fan_repair: 150,
//     Drill_wall_holes: 50,
//     Switch_repair: 150,
//     MCB_service: 100,
//     MDB_service: 200,
//     Fan_regulator_in_un: 120,
//     Fan_regulator_repair: 100,
//     Socket_in_un: 150,
//     Socket_repair: 100,
//     Circuit_breaker_repair: 250,
//     New_wiring_point: 350,
//     Coil_repair: 800,
//     Electrical_checkup: 100,
//   },

//   Plumber: {
//     Toilet_in: 250,
//     Faucet_in: 100,
//     Sink_in: 200,
//     Dishwasher_in: 200,
//     Leak_repair: 500,
//     Faucet_repair: 100,
//     Toilet_repair: 100,
//     Shower_repair: 100,
//     Drain_cleaning: 150,
//     pipe_cleaning: 300,
//     tank_cleaning: 800,
//     geyser_setup: 1200,
//     geyser_repair: 800,
//     issue_checkup: 250,
//   },

//   "Gas Chula": {
//     NewchulaSetup: 500,
//     chulaSetup: 300,
//     burnerSetup: 200,
//     burnerCleaning: 150,
//     nozzleReplacement: 120,
//     checkIssues: 100,
//   },

//   "AC Service": {
//     new_setup: 1500,
//     installation: 1200,
//     uninstallation: 800,
//     gas_refill: 1200,
//     cleaning: 600,
//     issue_checkup: 200,
//   },

//   Filter: {
//     new_filter_setup: 500,
//     installation_filter: 300,
//     uninstallation_filter: 200,
//     kit_replacement: 150,
//     pipe_leak_or_replace: 120,
//     full_servicing: 400,
//     check_up: 100,
//   },

//   "Tutor Service": {},
// };

// /* base/booking fee per service */
// const BOOKING_FEE = {
//   "Home Cleaning": 100,
//   Electrician: 100,
//   Plumber: 300,
//   "Gas Chula": 100,
//   "AC Service": 100,
//   Filter: 100,
//   "Tutor Service": 0,
// };

// const isTruthy = (v) =>
//   (typeof v === "number" && v > 0) ||
//   (typeof v === "boolean" && v) ||
//   (typeof v === "string" &&
//     v.trim() &&
//     !["no", "n/a", "any"].includes(v.trim().toLowerCase()));

// const money = (n) => `৳${Number(n || 0).toLocaleString("en-BD")}`;

// const ServitorInvoiceTemplate = forwardRef(({ order }, ref) => {
//   const serviceName = order.Service
//     ? order.Service.services_name
//     : order.service_name || "Unknown";

//   /* ---- fields (same as your original) ---- */
//   const serviceFields = {
//     "Home Cleaning": [
//       { key: "bed", label: "Bedroom" },
//       { key: "kitchen", label: "Kitchen" },
//       { key: "dra_din", label: "Drawing-Dining" },
//       { key: "bath", label: "Bathroom" },
//       { key: "balcony", label: "Balcony Cleaning" },
//       { key: "window_grill", label: "Window & Grill Cleaning" },
//       { key: "stairs_and_railing", label: "Stairs & Railing Cleaning" },
//       { key: "furniture_cleaning", label: "Furniture Cleaning" },
//       { key: "cloth", label: "Cloths" },
//       { key: "dish", label: "Dishes" },
//       { key: "carpet_cleaning", label: "Carpet Cleaning" },
//     ],
//     Electrician: [
//       { key: "Fan_in_un", label: "Fan Install" },
//       { key: "Light_in_un", label: "Light Install" },
//       { key: "Fan_repair", label: "Fan Repair" },
//       { key: "Light_repair", label: "Light Repair" },

//       { key: "Doorbell_setup", label: "Doorbell setup" },
//       { key: "Exhaust_fan_setup", label: "Exhaust fan setup" },
//       { key: "Exhaust_fan_repair", label: "Exhaust fan repair" },
//       { key: "Drill_wall_holes", label: "Drill wall holes" },

//       { key: "Switch_repair", label: "Switch Repair" },
//       { key: "MCB_service", label: "MCB Service" },
//       { key: "MDB_service", label: "MDB Service" },
//       { key: "Fan_regulator_in_un", label: "Regulator Install" },
//       { key: "Fan_regulator_repair", label: "Regulator Repair" },
//       { key: "Socket_in_un", label: "Socket Install" },
//       { key: "Socket_repair", label: "Socket Repair" },
//       { key: "Circuit_breaker_repair", label: "Breaker Repair" },
//       { key: "New_wiring_point", label: "New Wiring Point" },
//       { key: "Coil_repair", label: "Fan Coil Repair" },
//       { key: "Electrical_checkup", label: "Electrical Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     Plumber: [
//       { key: "Toilet_in", label: "Toilet Install" },
//       { key: "Faucet_in", label: "Faucet Install" },
//       { key: "Sink_in", label: "Sink Install" },
//       { key: "Dishwasher_in", label: "Dishwasher Install" },
//       { key: "Leak_repair", label: "Leak Repair" },
//       { key: "Faucet_repair", label: "Faucet Repair" },
//       { key: "Toilet_repair", label: "Toilet Repair" },
//       { key: "Shower_repair", label: "Shower Repair" },
//       { key: "Drain_cleaning", label: "Drain Cleaning" },
//       { key: "pipe_cleaning", label: "Pipe Cleaning" },
//       { key: "tank_cleaning", label: "Tank Cleaning" },
//       { key: "geyser_setup", label: "Geyser Install" },
//       { key: "geyser_repair", label: "Geyser Repair" },
//       { key: "issue_checkup", label: "Issue Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     "Gas Chula": [
//       { key: "chulaCylinderType", label: "Cylinder Type" },
//       { key: "NewchulaSetup", label: "New Chula Setup" },
//       { key: "chulaSetup", label: "Chula Setup" },
//       { key: "burnerSetup", label: "Burner Setup" },
//       { key: "burnerCleaning", label: "Burner Cleaning" },
//       { key: "nozzleReplacement", label: "Nozzle Replacement" },
//       { key: "checkIssues", label: "Check Issues", format: (v) => (v ? "Yes" : "No") },
//     ],
//     "AC Service": [
//       { key: "acType", label: "AC Type" },
//       { key: "acTon", label: "AC Ton" },
//       { key: "new_setup", label: "New Setup" },
//       { key: "installation", label: "Installation" },
//       { key: "uninstallation", label: "Uninstallation" },
//       { key: "gas_refill", label: "Gas Refill" },
//       { key: "cleaning", label: "Cleaning" },
//       { key: "issue_checkup", label: "Issue Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     Filter: [
//       { key: "filter_type", label: "Filter Type" },
//       { key: "new_filter_setup", label: "New Filter Setup" },
//       { key: "installation_filter", label: "Filter Installation" },
//       { key: "uninstallation_filter", label: "Filter Uninstallation" },
//       { key: "kit_replacement", label: "Kit Replacement" },
//       { key: "pipe_leak_or_replace", label: "Pipe Leak / Replace" },
//       { key: "full_servicing", label: "Full Servicing" },
//       { key: "check_up", label: "Issue Checkup", format: (v) => (v ? "Yes" : "No") },
//     ],
//     "Tutor Service": [
//       { key: "subject", label: "Subject" },
//       { key: "classLevel", label: "Class/Level" },
//       { key: "medium", label: "Medium" },
//       { key: "preferredTutorGender", label: "Preferred Tutor Gender", format: (v) => (String(v).toLowerCase() === "any" ? null : v) },
//       { key: "daysPerWeek", label: "Days per Week", format: (v) => `${v} day${Number(v) > 1 ? "s" : ""}/week` },
//       { key: "hoursPerDay", label: "Hours per Day", format: (v) => `${v} hour${Number(v) > 1 ? "s" : ""}/day` },
//       { key: "priorityInstitution", label: "Priority Institution" },
//       { key: "salary", label: "Salary", format: (v) => `৳${v}` },
//     ],
//   };

//   const fields = serviceFields[order.service_name] || [];
//   const priceMap = PRICE_TABLE[order.service_name] || {};
//   const bookingFee = BOOKING_FEE[order.service_name] ?? 0;
//   const isTutor = order.service_name === "Tutor Service";

//   // Build priced lines + descriptors
//   const lines = fields
//     .map(({ key, label, format }) => {
//       const raw = order[key];
//       if (raw === undefined || raw === null) return null;

//       const unitPrice = priceMap[key];
//       const display = format ? format(raw) : raw;

//       // Home Cleaning: first unit of these three is included
//       let chargeableQty = raw;
//       if (
//         order.service_name === "Home Cleaning" &&
//         (key === "bed" || key === "kitchen" || key === "dra_din")
//       ) {
//         chargeableQty = Math.max(0, Number(raw) - 1);
//       }

//       // boolean + priced -> flat fee (only when true)
//       if (typeof raw === "boolean" && raw === true && unitPrice) {
//         return {
//           key,
//           label,
//           qty: 1,
//           unitPrice,
//           lineTotal: unitPrice,
//           priceText: `1 × ${unitPrice}`,
//           descriptor: false,
//         };
//       }
//       if (typeof raw === "boolean") return null;

//       // numeric + priced
//       if (typeof raw === "number" && unitPrice) {
//         if (chargeableQty <= 0) return null;
//         return {
//           key,
//           label,
//           qty: chargeableQty,
//           unitPrice,
//           lineTotal: chargeableQty * unitPrice,
//           priceText:
//             order.service_name === "Home Cleaning" &&
//             (key === "bed" || key === "kitchen" || key === "dra_din")
//               ? `${chargeableQty} × ${unitPrice} (1st included)`
//               : `${chargeableQty} × ${unitPrice}`,
//           descriptor: false,
//         };
//       }

//       // descriptors (no price)
//       if (isTruthy(raw) && unitPrice === undefined) {
//         return {
//           key,
//           label,
//           descriptor: true,
//           descriptorValue: display,
//         };
//       }

//       return null;
//     })
//     .filter(Boolean);

//   const subTotal = lines
//     .filter((l) => !l.descriptor)
//     .reduce((acc, l) => acc + l.lineTotal, 0);

//   // discount only for non-tutor services
//   const discount = !isTutor ? Math.max(0, Number(order.discountValue || 0)) : 0;

//   // Tutor: no booking fee, total comes from order.price if provided; else subtotal
//   const baseTotal = isTutor ? (order.price ?? subTotal) : subTotal + bookingFee;
//   const grandTotal = Math.max(0, baseTotal - discount);

//   // 4-column grid chunk
//   const chunkedServices = [];
//   for (let i = 0; i < lines.length; i += 4) {
//     chunkedServices.push(lines.slice(i, i + 4));
//   }

//   return (
//     <div className="ServitorReceipt-container" ref={ref}>
//       {/* HEADER */}
//       <div className="ServitorReceipt-header">
//         <div className="ServitorReceipt-header-top">
//           <div className="ServitorReceipt-logo">HelpNao</div>
//           <div className="ServitorReceipt-number">
//             <h3>Servitor Receipt</h3>
//             <p>Order #{order.order_number}</p>
//           </div>
//         </div>

//         <div className="ServitorReceipt-order-info">
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Order Date</span>
//             <span className="ServitorReceipt-value">
//               {new Date(order.created_at).toLocaleDateString("en-US", {
//                 month: "long",
//                 day: "numeric",
//                 year: "numeric",
//               })}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Date</span>
//             <span className="ServitorReceipt-value">
//               {order.date
//                 ? new Date(order.date).toLocaleDateString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })
//                 : "TBD"}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Time</span>
//             <span className="ServitorReceipt-value">{order.time}</span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Status</span>
//             <span className="ServitorReceipt-status-badge">{order.status}</span>
//           </div>
//         </div>
//       </div>

//       <div className="ServitorReceipt-content">
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Service Details</h2>
//           <div className="ServitorReceipt-details-row">
//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Customer Information</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.User
//                     ? `${order.User.FirstName} ${order.User.LastName}`
//                     : "Unknown"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Location</span>
//                 <span className="ServitorReceipt-value">
//                   {(order.usercity || order.City) ?? "N/A"}
//                   {order.userarea || order.Area ? `, ${order.userarea || order.Area}` : ""}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.useraddress || order.Address || "N/A"}
//                 </span>
//               </div>
//             </div>

//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Service Provider</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Location</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.city || "N/A" : "N/A"}
//                   {order.Servitor && order.Servitor.area ? `, ${order.Servitor.area}` : ""}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.Address || "No Address" : "N/A"}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Services Provided */}
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Services Provided</h2>
//           <div className="ServitorReceipt-service-section">
//             <div className="ServitorReceipt-service-header">{serviceName}</div>
//             <div className="ServitorReceipt-service-table">
//               {chunkedServices.map((row, rowIdx) => (
//                 <div className="ServitorReceipt-service-row" key={rowIdx}>
//                   {row.map((svc, idx) => (
//                     <div className="ServitorReceipt-service-card" key={idx}>
//                       <div className="ServitorReceipt-service-name">{svc.label}</div>

//                       {"descriptor" in svc && svc.descriptor ? (
//                         <div className="ServitorReceipt-service-descriptor">
//                           {String(svc.descriptorValue)}
//                         </div>
//                       ) : (
//                         <div className="ServitorReceipt-service-quantity">
//                           {svc.priceText} = <strong>{money(svc.lineTotal)}</strong>
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                   {Array.from({ length: 4 - row.length }).map((_, idx) => (
//                     <div key={`empty-${idx}`} className="ServitorReceipt-service-card-empty"></div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Subtotal + Booking Fee + Discount (except Tutor) */}
//         {!isTutor && (
//           <div className="ServitorReceipt-subtotals">
//             <div className="ServitorReceipt-totals-row">
//               <span className="ServitorReceipt-total-label">Subtotal</span>
//               <span className="ServitorReceipt-total-value">{money(subTotal)}</span>
//             </div>
//             <div className="ServitorReceipt-totals-row">
//               <span className="ServitorReceipt-total-label">Booking Fee</span>
//               <span className="ServitorReceipt-total-value">{money(bookingFee)}</span>
//             </div>
//             {discount > 0 && (
//               <div className="ServitorReceipt-totals-row">
//                 <span className="ServitorReceipt-total-label">Discount</span>
//                 <span className="ServitorReceipt-total-value">−{money(discount)}</span>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Final Total */}
//         <div className="ServitorReceipt-total-section">
//           <div className="ServitorReceipt-total-label">Total Amount</div>
//           <div className="ServitorReceipt-total-amount">{money(grandTotal)}</div>
//         </div>
//       </div>

//       {/* FOOTER */}
//       <div className="ServitorReceipt-footer">
//         <div className="ServitorReceipt-footer-title">Thank you for serving with HelpNao!</div>
//         <div className="ServitorReceipt-footer-text">
//           Your dedication drives our success
//         </div>
//         <div className="ServitorReceipt-contact-info">
//           For support: support@HelpNao.com | +880123456789
//         </div>
//       </div>
//     </div>
//   );
// });

// export default ServitorInvoiceTemplate;
















// import React, { forwardRef } from "react";
// import "./ServitorInvoiceTemplate.css";
// import HelpNaoLogo from "../../../Assets/HelpNaoLogo.png";

// import {
//   SERVICE_PRICING,
//   AC_PRICING,
// } from "../../Services/servicePricing";

// /* ----------------------------- mappings -> pricing keys ----------------------------- */
// // Electrician
// // const MAP_ELECTRICIAN = {
// //   ceiling_fan_installation:       "ceilingFanInstallation",
// //   ceiling_fan_uninstallation:     "ceilingFanUninstallation",
// //   fan_coil_new_winding:           "fanCoilNewWinding",
// //   fan_coil_repair:                "fanCoilRepair",
// //   capacitor_setup:                "capacitorSetup",
// //   light_installation:             "lightInstallation",
// //   light_repair:                   "lightRepair",
// //   exhaust_fan_installation:       "exhaustFanInstallation",
// //   exhaust_fan_cleaning:           "exhaustFanCleaning",
// //   switch_setup:                   "switchSetup",
// //   socket_setup:                   "socketSetup",
// //   regulator_setup:                "regulatorSetup",
// //   new_wiring_point:               "newWiringPoint",
// //   main_circuit_board_setup:       "mainCircuitBoardSetup",
// //   doorbell_installation:          "doorbellInstallation",
// //   drill_hole_service:             "drillHoleService",
// //   ips_installation_existing_line: "ipsInstallationExistingLine",
// //   ips_new_line_installation:      "ipsNewLineInstallation",
// // };
// const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };

// // Plumber
// const MAP_PLUMBER = {
//   angle_valve_setup:                       "angleValveSetup",
//   basin_tap_setup:                         "basinTapSetup",
//   magic_pipe_setup:                        "magicPipeSetup",
//   basin_waste_pop_up_setup:                "basinWastePopUpSetup",
//   new_basin_setup_existing_lines:          "newBasinSetupExistingLines",

//   bathroom_tap_bib_cock_setup:             "bathroomTapBibCockSetup",
//   tissue_holder_setup:                     "tissueHolderSetup",
//   fill_valve_replacement:                  "fillValveReplacement",
//   hand_shower_setup:                       "handShowerSetup",
//   soap_dish_setup:                         "soapDishSetup",
//   bathroom_shelf_setup:                    "bathroomShelfSetup",
//   mirror_setup:                            "mirrorSetup",
//   towel_hanger_setup:                      "towelHangerSetup",
//   shower_head_setup:                       "showerHeadSetup",
//   concealed_stopcock_setup:                "concealedStopcockSetup",
//   floor_drain_net_setup:                   "floorDrainNetSetup",

//   toilet_seat_cover_replacement:           "toiletSeatCoverReplacement",
//   toilet_seat_complete_installation:       "toiletSeatCompleteInstallation",
//   high_commode_installation_existing_lines:"highCommodeInstallationExistingLines",
//   blockage_clearing_high_commode:          "blockageClearingHighCommode",
//   blockage_clearing_low_commode:           "blockageClearingLowCommode",

//   bathroom_drain_line_cleaning:            "bathroomDrainLineCleaning",
//   geyser_installation:                     "geyserInstallation",

//   kitchen_sink_setup_existing_lines:       "kitchenSinkSetupExistingLines",
//   sink_blockage_cleaning:                  "sinkBlockageCleaning",
//   washing_machine_point_setup:             "washingMachinePointSetup",
// };
// const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };

// // Gas Chula
// const MAP_GAS = {
//   NewchulaSetup: "newChulaSetup",
//   chulaSetup: "chulaSetup",
//   burnerSetup: "burnerSetup",
//   burnerCleaning: "burnerCleaning",
//   nozzleReplacement: "nozzleReplacement",
// };
// const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };

// // Filter
// const MAP_FILTER = {
//   new_filter_setup: "newFilterSetup",
//   installation_filter: "installationFilter",
//   uninstallation_filter: "uninstallationFilter",
//   kit_replacement: "kitReplacement",
//   pipe_leak_or_replace: "pipeLeakOrReplace",
//   full_servicing: "fullServicing",
// };
// const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };

// // Home Cleaning
// const MAP_HOME_FIRSTFREE = {
//   bed: "bedrooms",
//   kitchen: "kitchens",
//   dra_din: "drawingdinning",
// };
// const MAP_HOME_PERUNIT = {
//   bath: "bathrooms",
//   cloth: "cloths",
//   dish: "dishes",
//   balcony: "balconies",
//   window_grill: "windowGrills",
//   furniture_cleaning: "furniture",
//   stairs_and_railing: "stairsFloors",
//   carpet_cleaning: "carpets",
// };

// /* ----------------------------- utils ----------------------------- */
// const isTruthy = (v) =>
//   (typeof v === "number" && v > 0) ||
//   (typeof v === "boolean" && v) ||
//   (typeof v === "string" &&
//     v.trim() &&
//     !["no", "n/a", "any"].includes(v.trim().toLowerCase()));

// const money = (n) => `৳${Number(n || 0).toLocaleString("en-BD")}`;

// /* ----------------------------- AC helpers (correct tier logic) ----------------------------- */
// // Rule: 1 unit => use `first`; 2+ units => ALL units billed at `additional`
// const acPerUnitCost = (prop, qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return { total: 0, text: "" };

//   const rate = AC_PRICING?.perUnit?.[prop];
//   if (!rate) return { total: 0, text: "" };

//   if (c === 1) {
//     return { total: rate.first, text: `1 × ${rate.first}` };
//   }
//   const total = c * rate.additional;
//   return { total, text: `${c} × ${rate.additional}` };
// };

// // Checkup: base covers up to `includesUnits`, extras charged per AC above that
// const acCheckupCost = (qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return { total: 0, text: "" };

//   const { base = 0, includesUnits = 0, extraPerUnit = 0 } =
//     AC_PRICING.checkup || {};

//   if (c <= includesUnits) {
//     return {
//       total: base,
//       text: `${c} unit${c > 1 ? "s" : ""} — ${base}`,
//     };
//   }
//   const over = c - includesUnits;
//   const total = base + over * extraPerUnit;
//   return {
//     total,
//     text: `${includesUnits} — ${base} + ${over} × ${extraPerUnit}`,
//   };
// };

// const ServitorInvoiceTemplate = forwardRef(({ order }, ref) => {
//   const serviceName =
//     order?.Service?.services_name || order?.service_name || "Unknown";

//   /* ===================== visible fields for invoice ===================== */
//   const serviceFields = {
//     "Home Cleaning": [
//       { key: "bed", label: "Bedroom" },
//       { key: "kitchen", label: "Kitchen" },
//       { key: "dra_din", label: "Drawing-Dining" },
//       { key: "bath", label: "Bathroom" },
//       { key: "balcony", label: "Balcony Cleaning" },
//       { key: "window_grill", label: "Window & Grill Cleaning" },
//       { key: "stairs_and_railing", label: "Stairs & Railing Cleaning" },
//       { key: "furniture_cleaning", label: "Furniture Cleaning" },
//       { key: "cloth", label: "Cloths" },
//       { key: "dish", label: "Dishes" },
//       { key: "carpet_cleaning", label: "Carpet Cleaning" },
//     ],
//     Electrician: [
//       // { key: "Fan_in_un", label: "Fan Install" },
//       // { key: "Light_in_un", label: "Light Install" },
//       // { key: "Fan_repair", label: "Fan Repair" },
//       // { key: "Light_repair", label: "Light Repair" },
//       // { key: "Doorbell_setup", label: "Doorbell Setup" },
//       // { key: "Exhaust_fan_setup", label: "Exhaust Fan Setup" },
//       // { key: "Exhaust_fan_repair", label: "Exhaust Fan Repair" },
//       // { key: "Drill_wall_holes", label: "Drill Wall Holes" },
//       // { key: "Switch_repair", label: "Switch Repair" },
//       // { key: "MCB_service", label: "MCB Service" },
//       // { key: "MDB_service", label: "MDB Service" },
//       // { key: "Fan_regulator_in_un", label: "Regulator Install" },
//       // { key: "Fan_regulator_repair", label: "Regulator Repair" },
//       // { key: "Socket_in_un", label: "Socket Install" },
//       // { key: "Socket_repair", label: "Socket Repair" },
//       // { key: "Circuit_breaker_repair", label: "Breaker Repair" },
//       // { key: "New_wiring_point", label: "New Wiring Point" },
//       // { key: "Coil_repair", label: "Fan Coil Repair" },
//       // {
//       //   key: "Electrical_checkup",
//       //   label: "Electrical Checkup",
//       //   format: (v) => (v ? "Yes" : "No"),
//       // },

//       { key: "new_ceiling_fan_installation",   label: "New Ceiling Fan Installation" },
//       { key: "ceiling_fan_installation",       label: "Ceiling Fan Installation" },
//       { key: "ceiling_fan_uninstallation",     label: "Ceiling Fan Uninstallation" },
//       { key: "fan_coil_new_winding",           label: "Fan Coil New Winding" },
//       { key: "fan_coil_repair",                label: "Fan Coil Repair" },
//       { key: "capacitor_setup",                label: "Capacitor Setup" },
//       { key: "light_installation",             label: "Light Installation" },
//       { key: "light_repair",                   label: "Light Repair" },
//       { key: "exhaust_fan_installation",       label: "Exhaust Fan Installation" },
//       { key: "exhaust_fan_cleaning",           label: "Exhaust Fan Cleaning" },
//       { key: "switch_setup",                   label: "Switch setup" },
//       { key: "socket_setup",                   label: "Socket setup" },
//       { key: "regulator_setup",                label: "Regulator setup" },
//       { key: "new_wiring_point",               label: "New Wiring Point" },
//       { key: "main_circuit_board_setup",       label: "Setup Main Circuit board" },
//       { key: "doorbell_installation",          label: "setup Doorbell Installation" },
//       { key: "drill_hole_service",             label: "Drill Hole Service" },
//       { key: "ips_installation_existing_line", label: "IPS Installation (Existing Line)" },
//       { key: "ips_new_line_installation",      label: "IPS Installation (New Line)" },
//       { key: "Electrical_checkup",             label: "Electrical Checkup", format: v => (v ? "Yes" : "No") },
//     ],
//     Plumber: [
//       // { key: "Toilet_in", label: "Toilet Install" },
//       // { key: "Faucet_in", label: "Faucet Install" },
//       // { key: "Sink_in", label: "Sink Install" },
//       // { key: "Dishwasher_in", label: "Dishwasher Install" },
//       // { key: "Leak_repair", label: "Leak Repair" },
//       // { key: "Faucet_repair", label: "Faucet Repair" },
//       // { key: "Toilet_repair", label: "Toilet Repair" },
//       // { key: "Shower_repair", label: "Shower Repair" },
//       // { key: "Drain_cleaning", label: "Drain Cleaning" },
//       // { key: "pipe_cleaning", label: "Pipe Cleaning" },
//       // { key: "tank_cleaning", label: "Tank Cleaning" },
//       // { key: "geyser_setup", label: "Geyser Install" },
//       // { key: "geyser_repair", label: "Geyser Repair" },

//       // Basin & Kitchen
//       { key: "angle_valve_setup",              label: "Angle Valve Setup" },
//       { key: "basin_tap_setup",                label: "Basin Tap (Faucet) Setup" },
//       { key: "magic_pipe_setup",               label: "Magic Pipe (Flexible Drain) Setup" },
//       { key: "basin_waste_pop_up_setup",       label: "Basin Waste / Pop-Up Setup" },
//       { key: "new_basin_setup_existing_lines", label: "New Basin Setup (existing lines)" },
//       { key: "kitchen_sink_setup_existing_lines", label: "Kitchen Sink Setup (existing lines)" },
//       { key: "sink_blockage_cleaning",         label: "Sink Blockage Cleaning (1 sink line)" },

//       // Bathroom fittings
//       { key: "bathroom_tap_bib_cock_setup",    label: "Bathroom Tap Setup" },
//       { key: "tissue_holder_setup",            label: "Tissue Holder Setup" },
//       { key: "fill_valve_replacement",         label: "High Commode Ball Cock Replacement" },
//       { key: "hand_shower_setup",              label: "Hand Shower Setup" },
//       { key: "soap_dish_setup",                label: "Soap Stand Setup" },
//       { key: "bathroom_shelf_setup",           label: "Bathroom Shelf Setup" },
//       { key: "mirror_setup",                   label: "Looking Glass/Mirror Setup" },
//       { key: "towel_hanger_setup",             label: "Towel Hanger Setup" },
//       { key: "shower_head_setup",              label: "Shower Head Setup" },
//       { key: "concealed_stopcock_setup",       label: "Concealed Stopcock Valve Setup" },
//       { key: "floor_drain_net_setup",          label: "Floor Drain Net Setup" },

//       // Commode
//       { key: "toilet_seat_cover_replacement",  label: "Toilet Seat Cover Replacement (Standard)" },
//       { key: "toilet_seat_complete_installation", label: "Toilet Seat Complete Set Installation" },
//       { key: "high_commode_installation_existing_lines", label: "High Commode Toilet Installation (existing lines)" },
//       { key: "blockage_clearing_high_commode", label: "Blockage Clearing — High Commode" },
//       { key: "blockage_clearing_low_commode",  label: "Blockage Clearing — Low Commode" },

//       // Cleaning / heavy
//       { key: "bathroom_drain_line_cleaning",   label: "Bathroom Drain Line Cleaning (per bathroom)" },

//       // Geyser & points
//       { key: "geyser_installation",            label: "Geyser Installation (existing lines & power)" },
//       { key: "washing_machine_point_setup",    label: "Washing Machine Point Setup (existing lines)" },
//       {
//         key: "issue_checkup",
//         label: "Issue Checkup",
//         format: (v) => (v ? "Yes" : "No"),
//       },
//     ],
//     "Gas Chula": [
//       { key: "chulaCylinderType", label: "Cylinder Type" },
//       { key: "NewchulaSetup", label: "New Chula Setup" },
//       { key: "chulaSetup", label: "Chula Setup" },
//       { key: "burnerSetup", label: "Burner Setup" },
//       { key: "burnerCleaning", label: "Burner Cleaning" },
//       { key: "nozzleReplacement", label: "Nozzle Replacement" },
//       {
//         key: "checkIssues",
//         label: "Check Issues",
//         format: (v) => (v ? "Yes" : "No"),
//       },
//     ],
//     // ⬇️ UPDATED AC FIELDS
//     "AC Service": [
//       { key: "acType", label: "AC Type" },
//       { key: "acTon", label: "AC Ton" },

//       { key: "installation_outdoor_inside", label: "Installation (Outdoor Inside)" },
//       { key: "installation_outdoor_outside", label: "Installation (Outdoor Outside)" },

//       { key: "uninstallation_outdoor_inside", label: "Uninstallation (Outdoor Inside)" },
//       { key: "uninstallation_outdoor_outside", label: "Uninstallation (Outdoor Outside)" },

//       { key: "cleaning_outdoor_inside", label: "Cleaning (Outdoor Inside)" },
//       { key: "cleaning_outdoor_outside", label: "Cleaning (Outdoor Outside)" },

//       { key: "issue_checkup", label: "AC Checkup (No. of AC)" }, // numeric
//       { key: "remarks", label: "Remarks" },
//     ],
//     Filter: [
//       { key: "filter_type", label: "Filter Type" },
//       { key: "new_filter_setup", label: "New Filter Setup" },
//       { key: "installation_filter", label: "Filter Installation" },
//       { key: "uninstallation_filter", label: "Filter Uninstallation" },
//       { key: "kit_replacement", label: "Kit Replacement" },
//       { key: "pipe_leak_or_replace", label: "Pipe Leak / Replace" },
//       { key: "full_servicing", label: "Full Servicing" },
//       {
//         key: "check_up",
//         label: "Issue Checkup",
//         format: (v) => (v ? "Yes" : "No"),
//       },
//     ],
//     "Tutor Service": [
//       { key: "subject", label: "Subject" },
//       { key: "classLevel", label: "Class/Level" },
//       { key: "medium", label: "Medium" },
//       {
//         key: "preferredTutorGender",
//         label: "Preferred Tutor Gender",
//         format: (v) => (String(v).toLowerCase() === "any" ? null : v),
//       },
//       {
//         key: "daysPerWeek",
//         label: "Days per Week",
//         format: (v) => `${v} day${Number(v) > 1 ? "s" : ""}/week`,
//       },
//       {
//         key: "hoursPerDay",
//         label: "Hours per Day",
//         format: (v) => `${v} hour${Number(v) > 1 ? "s" : ""}/day`,
//       },
//       { key: "priorityInstitution", label: "Priority Institution" },
//       { key: "salary", label: "Salary", format: (v) => `৳${v}` },
//     ],
//   };

//   const fields = serviceFields[serviceName] || [];
//   const svcPricing = SERVICE_PRICING[serviceName];
//   const bookingFee =
//     serviceName === "Tutor Service" ? 0 : (svcPricing?.base ?? 0);
//   const isTutor = serviceName === "Tutor Service";

//   /* ----------------------------- build line items ----------------------------- */
//   const lines = fields
//     .map(({ key, label, format }) => {
//       const raw = order?.[key];
//       if (raw === undefined || raw === null) return null;

//       const formatted = format ? format(raw) : raw;

//       // ---------- AC (tier logic + numeric checkup) ----------
//       if (serviceName === "AC Service") {
//         // descriptors
//         if (["acType", "acTon", "remarks"].includes(key) && isTruthy(formatted)) {
//           return { key, label, descriptor: true, descriptorValue: formatted };
//         }

//         // numeric per-unit (tiered)
//         if (
//           [
//             "installation_outdoor_inside",
//             "installation_outdoor_outside",
//             "uninstallation_outdoor_inside",
//             "uninstallation_outdoor_outside",
//             "cleaning_outdoor_inside",
//             "cleaning_outdoor_outside",
//           ].includes(key)
//         ) {
//           const qty = Number(raw || 0);
//           if (qty <= 0) return null;
//           const { total, text } = acPerUnitCost(key, qty); // uses corrected rule
//           return {
//             key,
//             label,
//             qty,
//             lineTotal: total,
//             priceText: text, // e.g., "2 × 1100"
//             descriptor: false,
//           };
//         }

//         // numeric AC checkup
//         if (key === "issue_checkup") {
//           const qty = Number(raw || 0);
//           if (qty <= 0) return null;
//           const { total, text } = acCheckupCost(qty);
//           return {
//             key,
//             label,
//             qty,
//             lineTotal: total,
//             priceText: text, // e.g., "2 — 500 + 1 × 200"
//             descriptor: false,
//           };
//         }

//         // anything else in AC is descriptor-only
//         if (isTruthy(formatted)) {
//           return { key, label, descriptor: true, descriptorValue: formatted };
//         }
//         return null;
//       }

//       // ---------- Home Cleaning ----------
//       if (serviceName === "Home Cleaning") {
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;

//         // first-free group
//         const ffKey = MAP_HOME_FIRSTFREE[key];
//         if (ffKey && svcPricing?.firstFree?.[ffKey]) {
//           const perAdditional = svcPricing.firstFree[ffKey].perAdditional || 0;
//           const chargeable = Math.max(0, qty - 1);
//           if (chargeable <= 0) {
//             return {
//               key,
//               label,
//               qty,
//               unitPrice: perAdditional,
//               lineTotal: 0,
//               priceText: `0 × ${perAdditional} (1st included)`,
//               descriptor: false,
//             };
//           }
//           return {
//             key,
//             label,
//             qty: chargeable,
//             unitPrice: perAdditional,
//             lineTotal: chargeable * perAdditional,
//             priceText: `${chargeable} × ${perAdditional} (1st included)`,
//             descriptor: false,
//           };
//         }

//         // straight per-unit
//         const puKey = MAP_HOME_PERUNIT[key];
//         const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
//         if (rate && qty > 0) {
//           return {
//             key,
//             label,
//             qty,
//             unitPrice: rate,
//             lineTotal: qty * rate,
//             priceText: `${qty} × ${rate}`,
//             descriptor: false,
//           };
//         }
//         return null;
//       }

//       // ---------- Electrician ----------
//       if (serviceName === "Electrician") {
//         if (typeof raw === "boolean") {
//           if (!raw) return null;
//           const flatKey = ELEC_BOOL_FLAT[key];
//           const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//           if (!flat) return null;
//           return {
//             key,
//             label,
//             qty: 1,
//             unitPrice: flat,
//             lineTotal: flat,
//             priceText: `1 × ${flat}`,
//             descriptor: false,
//           };
//         }
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         // const pKey = MAP_ELECTRICIAN[key];
//         // const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;

//         // const rate = svcPricing?.perUnit?.[key];
//         // const unitPrice = Number.isFinite(rate) ? rate : 0;
//         // const hasRate = Number.isFinite(rate);

//         const rate = svcPricing?.perUnit?.[key];
//         const hasRate = Number.isFinite(rate);
//         if (!hasRate) return null;
//         const unitPrice = rate;

//         // if (!rate) return null;
//         return {
//           key,
//           label,
//           qty,
//           // unitPrice: rate,
//           // lineTotal: qty * rate,
//           // priceText: `${qty} × ${rate}`,
//           unitPrice,
//           lineTotal: qty * unitPrice,
//           // priceText: hasRate ? `${qty} × ${unitPrice}` : `${qty} × (no price set)`,
//           priceText: `${qty} × ${unitPrice}`,
//           descriptor: false,
//         };
//       }

//       // ---------- Plumber ----------
//       if (serviceName === "Plumber") {
//         if (typeof raw === "boolean") {
//           if (!raw) return null;
//           const flatKey = PLUMBER_BOOL_FLAT[key];
//           const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//           if (!flat) return null;
//           return {
//             key,
//             label,
//             qty: 1,
//             unitPrice: flat,
//             lineTotal: flat,
//             priceText: `1 × ${flat}`,
//             descriptor: false,
//           };
//         }
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         const pKey = MAP_PLUMBER[key];
//         const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
//         if (!rate) return null;
//         return {
//           key,
//           label,
//           qty,
//           unitPrice: rate,
//           lineTotal: qty * rate,
//           priceText: `${qty} × ${rate}`,
//           descriptor: false,
//         };
//       }

//       // ---------- Gas Chula ----------
//       if (serviceName === "Gas Chula") {
//         if (typeof raw === "boolean") {
//           if (!raw) return null;
//           const flatKey = GAS_BOOL_FLAT[key];
//           const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//           if (!flat) return null;
//           return {
//             key,
//             label,
//             qty: 1,
//             unitPrice: flat,
//             lineTotal: flat,
//             priceText: `1 × ${flat}`,
//             descriptor: false,
//           };
//         }
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         const pKey = MAP_GAS[key];
//         const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
//         if (!rate) return null;
//         return {
//           key,
//           label,
//           qty,
//           unitPrice: rate,
//           lineTotal: qty * rate,
//           priceText: `${qty} × ${rate}`,
//           descriptor: false,
//         };
//       }

//       // ---------- Filter ----------
//       if (serviceName === "Filter") {
//         if (typeof raw === "boolean") {
//           if (!raw) return null;
//           const flatKey = FILTER_BOOL_FLAT[key];
//           const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//           if (!flat) return null;
//           return {
//             key,
//             label,
//             qty: 1,
//             unitPrice: flat,
//             lineTotal: flat,
//             priceText: `1 × ${flat}`,
//             descriptor: false,
//           };
//         }
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         const pKey = MAP_FILTER[key];
//         const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
//         if (!rate) return null;
//         return {
//           key,
//           label,
//           qty,
//           unitPrice: rate,
//           lineTotal: qty * rate,
//           priceText: `${qty} × ${rate}`,
//           descriptor: false,
//         };
//       }

//       // ---------- Tutor / Others: descriptors only ----------
//       if (isTruthy(formatted)) {
//         return { key, label, descriptor: true, descriptorValue: formatted };
//       }
//       return null;
//     })
//     .filter(Boolean);

//   const subTotal = lines
//     .filter((l) => !l.descriptor)
//     .reduce((acc, l) => acc + l.lineTotal, 0);

//   const discount =
//     serviceName === "Tutor Service"
//       ? 0
//       : Math.max(0, Number(order?.discountValue || 0));

//   const extraCharge = !isTutor
//     ? Math.max(0, Number(order?.extraCharge || 0))
//     : 0;

//   const baseTotal =
//     serviceName === "Tutor Service"
//       ? order?.price ?? subTotal
//       : subTotal + bookingFee;

//   const computedFinal = Math.max(0, baseTotal - discount + extraCharge);
  
//   // const grandTotal = Math.max(0, baseTotal - discount);
//   const grandTotal = Number.isFinite(Number(order?.price))
//     ? Number(order.price)
//     : computedFinal;

//   // 4-column grid chunk
//   const chunkedServices = [];
//   for (let i = 0; i < lines.length; i += 4) {
//     chunkedServices.push(lines.slice(i, i + 4));
//   }

//   return (
//     <div className="ServitorReceipt-container" ref={ref}>
//       {/* HEADER */}
//       <div className="ServitorReceipt-header">
//         <div className="ServitorReceipt-header-top">
//           {/* <div className="ServitorReceipt-logo">HelpNao</div> */}

//           <div className="ServitorReceipt-brand">
//             <div className="ServitorReceipt-logo-circle">
//               <img
//                 src={HelpNaoLogo}
//                 alt="HelpNao logo"
//                 className="ServitorReceipt-logo-img"
//               />
//             </div>
//             <div className="ServitorReceipt-brand-text">HelpNao</div>
//           </div>

//           <div className="ServitorReceipt-number">
//             <h3>Servitor Receipt</h3>
//             <p>Order #{order.order_number}</p>
//           </div>
//         </div>

//         <div className="ServitorReceipt-order-info">
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Order Date</span>
//             <span className="ServitorReceipt-value">
//               {new Date(order.created_at).toLocaleDateString("en-US", {
//                 month: "long",
//                 day: "numeric",
//                 year: "numeric",
//               })}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Date</span>
//             <span className="ServitorReceipt-value">
//               {order.date
//                 ? new Date(order.date).toLocaleDateString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })
//                 : "TBD"}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Time</span>
//             <span className="ServitorReceipt-value">{order.time}</span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Status</span>
//             <span className="ServitorReceipt-status-badge">{order.status}</span>
//           </div>
//         </div>
//       </div>

//       <div className="ServitorReceipt-content">
//         {/* Service Details */}
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Service Details</h2>
//           <div className="ServitorReceipt-details-row">
//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Customer Information</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.User
//                     ? `${order.User.FirstName} ${order.User.LastName}`
//                     : "Unknown"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Location</span>
//                 <span className="ServitorReceipt-value">
//                   {(order.usercity || order.City) ?? "N/A"}
//                   {order.userarea || order.Area
//                     ? `, ${order.userarea || order.Area}`
//                     : ""}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.useraddress || order.Address || "N/A"}
//                 </span>
//               </div>
//             </div>

//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Service Provider</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Location</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.city || "N/A" : "N/A"}
//                   {order.Servitor && order.Servitor.area
//                     ? `, ${order.Servitor.area}`
//                     : ""}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.Address || "No Address" : "N/A"}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Services Provided */}
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Services Provided</h2>
//           <div className="ServitorReceipt-service-section">
//             <div className="ServitorReceipt-service-header">{serviceName}</div>
//             <div className="ServitorReceipt-service-table">
//               {(() => {
//                 if (lines.length === 0) {
//                   return (
//                     <div className="ServitorReceipt-service-row">
//                       <div className="ServitorReceipt-service-card">
//                         <div className="ServitorReceipt-service-name">
//                           No billable items.
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 }
//                 return chunkedServices.map((row, rowIdx) => (
//                   <div className="ServitorReceipt-service-row" key={rowIdx}>
//                     {row.map((svc, idx) => (
//                       <div className="ServitorReceipt-service-card" key={idx}>
//                         <div className="ServitorReceipt-service-name">{svc.label}</div>

//                         {"descriptor" in svc && svc.descriptor ? (
//                           <div className="ServitorReceipt-service-descriptor">
//                             {String(svc.descriptorValue)}
//                           </div>
//                         ) : (
//                           <div className="ServitorReceipt-service-quantity">
//                             {svc.priceText} = <strong>{money(svc.lineTotal)}</strong>
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                     {Array.from({ length: 4 - row.length }).map((_, idx) => (
//                       <div
//                         key={`empty-${idx}`}
//                         className="ServitorReceipt-service-card-empty"
//                       />
//                     ))}
//                   </div>
//                 ));
//               })()}
//             </div>
//           </div>
//         </div>

//         {/* Subtotal + Booking Fee + Discount (except Tutor) */}
//         {!isTutor && (
//           <div className="ServitorReceipt-subtotals">
//             <div className="ServitorReceipt-totals-row">
//               <span className="ServitorReceipt-total-label">Subtotal</span>
//               <span className="ServitorReceipt-total-value">{money(subTotal)}</span>
//             </div>
//             <div className="ServitorReceipt-totals-row">
//               {/* <span className="ServitorReceipt-total-label">Booking Fee</span> */}
//               <span className="ServitorReceipt-total-label">Platform & Support Fee</span>
//               <span className="ServitorReceipt-total-value">{money(bookingFee)}</span>
//             </div>
//             {Number(discount) > 0 && (
//               <div className="ServitorReceipt-totals-row">
//                 <span className="ServitorReceipt-total-label">Discount</span>
//                 <span className="ServitorReceipt-total-value">
//                   −{money(discount)}
//                 </span>
//               </div>
//             )}

//             {Number(extraCharge) > 0 && (
//               <div className="ServitorReceipt-totals-row">
//                 <span className="ServitorReceipt-total-label">
//                   Extra Service Charge
//                 </span>
//                 <span className="ServitorReceipt-total-value">
//                   +{money(extraCharge)}
//                 </span>
//               </div>
//             )}
            
//           </div>
//         )}

//         {/* Final Total */}
//         <div className="ServitorReceipt-total-section">
//           <div className="ServitorReceipt-total-label">Total Amount</div>
//           <div className="ServitorReceipt-total-amount">{money(grandTotal)}</div>
//         </div>
//       </div>

//       {/* FOOTER */}
//       <div className="ServitorReceipt-footer">
//         <div className="ServitorReceipt-footer-title">
//           Thank you for serving with HelpNao!
//         </div>
//         <div className="ServitorReceipt-footer-text">
//           Your dedication drives our success
//         </div>
//         <div className="ServitorReceipt-contact-info">
//           For support: helpnao.com@gmail.com | +8801779256378
//         </div>
//       </div>
//     </div>
//   );
// });

// export default ServitorInvoiceTemplate;





// ***** Update New Update for drill holes electrician (1-january-2026) ***** //
// import React, { forwardRef } from "react";
// import "./ServitorInvoiceTemplate.css";
// import HelpNaoLogo from "../../../Assets/HelpNaoLogo.png";

// import {
//   SERVICE_PRICING,
//   AC_PRICING,
// } from "../../Services/servicePricing";

// /* ----------------------------- mappings -> pricing keys ----------------------------- */
// // Electrician
// // const MAP_ELECTRICIAN = {
// //   ceiling_fan_installation:       "ceilingFanInstallation",
// //   ceiling_fan_uninstallation:     "ceilingFanUninstallation",
// //   fan_coil_new_winding:           "fanCoilNewWinding",
// //   fan_coil_repair:                "fanCoilRepair",
// //   capacitor_setup:                "capacitorSetup",
// //   light_installation:             "lightInstallation",
// //   light_repair:                   "lightRepair",
// //   exhaust_fan_installation:       "exhaustFanInstallation",
// //   exhaust_fan_cleaning:           "exhaustFanCleaning",
// //   switch_setup:                   "switchSetup",
// //   socket_setup:                   "socketSetup",
// //   regulator_setup:                "regulatorSetup",
// //   new_wiring_point:               "newWiringPoint",
// //   main_circuit_board_setup:       "mainCircuitBoardSetup",
// //   doorbell_installation:          "doorbellInstallation",
// //   drill_hole_service:             "drillHoleService",
// //   ips_installation_existing_line: "ipsInstallationExistingLine",
// //   ips_new_line_installation:      "ipsNewLineInstallation",
// // };
// const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };

// // Plumber
// const MAP_PLUMBER = {
//   angle_valve_setup:                       "angleValveSetup",
//   basin_tap_setup:                         "basinTapSetup",
//   magic_pipe_setup:                        "magicPipeSetup",
//   basin_waste_pop_up_setup:                "basinWastePopUpSetup",
//   new_basin_setup_existing_lines:          "newBasinSetupExistingLines",

//   bathroom_tap_bib_cock_setup:             "bathroomTapBibCockSetup",
//   tissue_holder_setup:                     "tissueHolderSetup",
//   fill_valve_replacement:                  "fillValveReplacement",
//   hand_shower_setup:                       "handShowerSetup",
//   soap_dish_setup:                         "soapDishSetup",
//   bathroom_shelf_setup:                    "bathroomShelfSetup",
//   mirror_setup:                            "mirrorSetup",
//   towel_hanger_setup:                      "towelHangerSetup",
//   shower_head_setup:                       "showerHeadSetup",
//   concealed_stopcock_setup:                "concealedStopcockSetup",
//   floor_drain_net_setup:                   "floorDrainNetSetup",

//   toilet_seat_cover_replacement:           "toiletSeatCoverReplacement",
//   toilet_seat_complete_installation:       "toiletSeatCompleteInstallation",
//   high_commode_installation_existing_lines:"highCommodeInstallationExistingLines",
//   blockage_clearing_high_commode:          "blockageClearingHighCommode",
//   blockage_clearing_low_commode:           "blockageClearingLowCommode",

//   bathroom_drain_line_cleaning:            "bathroomDrainLineCleaning",
//   geyser_installation:                     "geyserInstallation",

//   kitchen_sink_setup_existing_lines:       "kitchenSinkSetupExistingLines",
//   sink_blockage_cleaning:                  "sinkBlockageCleaning",
//   washing_machine_point_setup:             "washingMachinePointSetup",
// };
// const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };

// // Gas Chula
// const MAP_GAS = {
//   NewchulaSetup: "newChulaSetup",
//   chulaSetup: "chulaSetup",
//   burnerSetup: "burnerSetup",
//   burnerCleaning: "burnerCleaning",
//   nozzleReplacement: "nozzleReplacement",
// };
// const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };

// // Filter
// const MAP_FILTER = {
//   new_filter_setup: "newFilterSetup",
//   installation_filter: "installationFilter",
//   uninstallation_filter: "uninstallationFilter",
//   kit_replacement: "kitReplacement",
//   pipe_leak_or_replace: "pipeLeakOrReplace",
//   full_servicing: "fullServicing",
// };
// const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };

// // Home Cleaning
// const MAP_HOME_FIRSTFREE = {
//   bed: "bedrooms",
//   kitchen: "kitchens",
//   dra_din: "drawingdinning",
// };
// const MAP_HOME_PERUNIT = {
//   bath: "bathrooms",
//   cloth: "cloths",
//   dish: "dishes",
//   balcony: "balconies",
//   window_grill: "windowGrills",
//   furniture_cleaning: "furniture",
//   stairs_and_railing: "stairsFloors",
//   carpet_cleaning: "carpets",
// };

// /* ----------------------------- utils ----------------------------- */
// const isTruthy = (v) =>
//   (typeof v === "number" && v > 0) ||
//   (typeof v === "boolean" && v) ||
//   (typeof v === "string" &&
//     v.trim() &&
//     !["no", "n/a", "any"].includes(v.trim().toLowerCase()));

// const money = (n) => `৳${Number(n || 0).toLocaleString("en-BD")}`;

// /* ----------------------------- AC helpers (correct tier logic) ----------------------------- */
// // Rule: 1 unit => use `first`; 2+ units => ALL units billed at `additional`
// const acPerUnitCost = (prop, qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return { total: 0, text: "" };

//   const rate = AC_PRICING?.perUnit?.[prop];
//   if (!rate) return { total: 0, text: "" };

//   if (c === 1) {
//     return { total: rate.first, text: `1 × ${rate.first}` };
//   }
//   const total = c * rate.additional;
//   return { total, text: `${c} × ${rate.additional}` };
// };

// // Checkup: base covers up to `includesUnits`, extras charged per AC above that
// const acCheckupCost = (qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return { total: 0, text: "" };

//   const { base = 0, includesUnits = 0, extraPerUnit = 0 } =
//     AC_PRICING.checkup || {};

//   if (c <= includesUnits) {
//     return {
//       total: base,
//       text: `${c} unit${c > 1 ? "s" : ""} — ${base}`,
//     };
//   }
//   const over = c - includesUnits;
//   const total = base + over * extraPerUnit;
//   return {
//     total,
//     text: `${includesUnits} — ${base} + ${over} × ${extraPerUnit}`,
//   };
// };

// const ServitorInvoiceTemplate = forwardRef(({ order }, ref) => {
//   const serviceName =
//     order?.Service?.services_name || order?.service_name || "Unknown";

//   /* ===================== visible fields for invoice ===================== */
//   const serviceFields = {
//     "Home Cleaning": [
//       { key: "bed", label: "Bedroom" },
//       { key: "kitchen", label: "Kitchen" },
//       { key: "dra_din", label: "Drawing-Dining" },
//       { key: "bath", label: "Bathroom" },
//       { key: "balcony", label: "Balcony Cleaning" },
//       { key: "window_grill", label: "Window & Grill Cleaning" },
//       { key: "stairs_and_railing", label: "Stairs & Railing Cleaning" },
//       { key: "furniture_cleaning", label: "Furniture Cleaning" },
//       { key: "cloth", label: "Cloths" },
//       { key: "dish", label: "Dishes" },
//       { key: "carpet_cleaning", label: "Carpet Cleaning" },
//     ],
//     Electrician: [
//       // { key: "Fan_in_un", label: "Fan Install" },
//       // { key: "Light_in_un", label: "Light Install" },
//       // { key: "Fan_repair", label: "Fan Repair" },
//       // { key: "Light_repair", label: "Light Repair" },
//       // { key: "Doorbell_setup", label: "Doorbell Setup" },
//       // { key: "Exhaust_fan_setup", label: "Exhaust Fan Setup" },
//       // { key: "Exhaust_fan_repair", label: "Exhaust Fan Repair" },
//       // { key: "Drill_wall_holes", label: "Drill Wall Holes" },
//       // { key: "Switch_repair", label: "Switch Repair" },
//       // { key: "MCB_service", label: "MCB Service" },
//       // { key: "MDB_service", label: "MDB Service" },
//       // { key: "Fan_regulator_in_un", label: "Regulator Install" },
//       // { key: "Fan_regulator_repair", label: "Regulator Repair" },
//       // { key: "Socket_in_un", label: "Socket Install" },
//       // { key: "Socket_repair", label: "Socket Repair" },
//       // { key: "Circuit_breaker_repair", label: "Breaker Repair" },
//       // { key: "New_wiring_point", label: "New Wiring Point" },
//       // { key: "Coil_repair", label: "Fan Coil Repair" },
//       // {
//       //   key: "Electrical_checkup",
//       //   label: "Electrical Checkup",
//       //   format: (v) => (v ? "Yes" : "No"),
//       // },

//       { key: "new_ceiling_fan_installation",   label: "New Ceiling Fan Installation" },
//       { key: "ceiling_fan_installation",       label: "Ceiling Fan Installation" },
//       { key: "ceiling_fan_uninstallation",     label: "Ceiling Fan Uninstallation" },
//       { key: "fan_coil_new_winding",           label: "Fan Coil New Winding" },
//       { key: "fan_coil_repair",                label: "Fan Coil Repair" },
//       { key: "capacitor_setup",                label: "Capacitor Setup" },
//       { key: "light_installation",             label: "Light Installation" },
//       { key: "light_repair",                   label: "Light Repair" },
//       { key: "exhaust_fan_installation",       label: "Exhaust Fan Installation" },
//       { key: "exhaust_fan_cleaning",           label: "Exhaust Fan Cleaning" },
//       { key: "switch_setup",                   label: "Switch setup" },
//       { key: "socket_setup",                   label: "Socket setup" },
//       { key: "regulator_setup",                label: "Regulator setup" },
//       { key: "new_wiring_point",               label: "New Wiring Point" },
//       { key: "main_circuit_board_setup",       label: "Setup Main Circuit board" },
//       { key: "doorbell_installation",          label: "setup Doorbell Installation" },
//       { key: "drill_hole_service",             label: "Drill Hole Service" },
//       { key: "ips_installation_existing_line", label: "IPS Installation (Existing Line)" },
//       { key: "ips_new_line_installation",      label: "IPS Installation (New Line)" },
//       { key: "Electrical_checkup",             label: "Electrical Checkup", format: v => (v ? "Yes" : "No") },
//     ],
//     Plumber: [
//       // { key: "Toilet_in", label: "Toilet Install" },
//       // { key: "Faucet_in", label: "Faucet Install" },
//       // { key: "Sink_in", label: "Sink Install" },
//       // { key: "Dishwasher_in", label: "Dishwasher Install" },
//       // { key: "Leak_repair", label: "Leak Repair" },
//       // { key: "Faucet_repair", label: "Faucet Repair" },
//       // { key: "Toilet_repair", label: "Toilet Repair" },
//       // { key: "Shower_repair", label: "Shower Repair" },
//       // { key: "Drain_cleaning", label: "Drain Cleaning" },
//       // { key: "pipe_cleaning", label: "Pipe Cleaning" },
//       // { key: "tank_cleaning", label: "Tank Cleaning" },
//       // { key: "geyser_setup", label: "Geyser Install" },
//       // { key: "geyser_repair", label: "Geyser Repair" },

//       // Basin & Kitchen
//       { key: "angle_valve_setup",              label: "Angle Valve Setup" },
//       { key: "basin_tap_setup",                label: "Basin Tap (Faucet) Setup" },
//       { key: "magic_pipe_setup",               label: "Magic Pipe (Flexible Drain) Setup" },
//       { key: "basin_waste_pop_up_setup",       label: "Basin Waste / Pop-Up Setup" },
//       { key: "new_basin_setup_existing_lines", label: "New Basin Setup (existing lines)" },
//       { key: "kitchen_sink_setup_existing_lines", label: "Kitchen Sink Setup (existing lines)" },
//       { key: "sink_blockage_cleaning",         label: "Sink Blockage Cleaning (1 sink line)" },

//       // Bathroom fittings
//       { key: "bathroom_tap_bib_cock_setup",    label: "Bathroom Tap Setup" },
//       { key: "tissue_holder_setup",            label: "Tissue Holder Setup" },
//       { key: "fill_valve_replacement",         label: "High Commode Ball Cock Replacement" },
//       { key: "hand_shower_setup",              label: "Hand Shower Setup" },
//       { key: "soap_dish_setup",                label: "Soap Stand Setup" },
//       { key: "bathroom_shelf_setup",           label: "Bathroom Shelf Setup" },
//       { key: "mirror_setup",                   label: "Looking Glass/Mirror Setup" },
//       { key: "towel_hanger_setup",             label: "Towel Hanger Setup" },
//       { key: "shower_head_setup",              label: "Shower Head Setup" },
//       { key: "concealed_stopcock_setup",       label: "Concealed Stopcock Valve Setup" },
//       { key: "floor_drain_net_setup",          label: "Floor Drain Net Setup" },

//       // Commode
//       { key: "toilet_seat_cover_replacement",  label: "Toilet Seat Cover Replacement (Standard)" },
//       { key: "toilet_seat_complete_installation", label: "Toilet Seat Complete Set Installation" },
//       { key: "high_commode_installation_existing_lines", label: "High Commode Toilet Installation (existing lines)" },
//       { key: "blockage_clearing_high_commode", label: "Blockage Clearing — High Commode" },
//       { key: "blockage_clearing_low_commode",  label: "Blockage Clearing — Low Commode" },

//       // Cleaning / heavy
//       { key: "bathroom_drain_line_cleaning",   label: "Bathroom Drain Line Cleaning (per bathroom)" },

//       // Geyser & points
//       { key: "geyser_installation",            label: "Geyser Installation (existing lines & power)" },
//       { key: "washing_machine_point_setup",    label: "Washing Machine Point Setup (existing lines)" },
//       {
//         key: "issue_checkup",
//         label: "Issue Checkup",
//         format: (v) => (v ? "Yes" : "No"),
//       },
//     ],
//     "Gas Chula": [
//       { key: "chulaCylinderType", label: "Cylinder Type" },
//       { key: "NewchulaSetup", label: "New Chula Setup" },
//       { key: "chulaSetup", label: "Chula Setup" },
//       { key: "burnerSetup", label: "Burner Setup" },
//       { key: "burnerCleaning", label: "Burner Cleaning" },
//       { key: "nozzleReplacement", label: "Nozzle Replacement" },
//       {
//         key: "checkIssues",
//         label: "Check Issues",
//         format: (v) => (v ? "Yes" : "No"),
//       },
//     ],
//     // ⬇️ UPDATED AC FIELDS
//     "AC Service": [
//       { key: "acType", label: "AC Type" },
//       { key: "acTon", label: "AC Ton" },

//       { key: "installation_outdoor_inside", label: "Installation (Outdoor Inside)" },
//       { key: "installation_outdoor_outside", label: "Installation (Outdoor Outside)" },

//       { key: "uninstallation_outdoor_inside", label: "Uninstallation (Outdoor Inside)" },
//       { key: "uninstallation_outdoor_outside", label: "Uninstallation (Outdoor Outside)" },

//       { key: "cleaning_outdoor_inside", label: "Cleaning (Outdoor Inside)" },
//       { key: "cleaning_outdoor_outside", label: "Cleaning (Outdoor Outside)" },

//       { key: "issue_checkup", label: "AC Checkup (No. of AC)" }, // numeric
//       { key: "remarks", label: "Remarks" },
//     ],
//     Filter: [
//       { key: "filter_type", label: "Filter Type" },
//       { key: "new_filter_setup", label: "New Filter Setup" },
//       { key: "installation_filter", label: "Filter Installation" },
//       { key: "uninstallation_filter", label: "Filter Uninstallation" },
//       { key: "kit_replacement", label: "Kit Replacement" },
//       { key: "pipe_leak_or_replace", label: "Pipe Leak / Replace" },
//       { key: "full_servicing", label: "Full Servicing" },
//       {
//         key: "check_up",
//         label: "Issue Checkup",
//         format: (v) => (v ? "Yes" : "No"),
//       },
//     ],
//     "Tutor Service": [
//       { key: "subject", label: "Subject" },
//       { key: "classLevel", label: "Class/Level" },
//       { key: "medium", label: "Medium" },
//       {
//         key: "preferredTutorGender",
//         label: "Preferred Tutor Gender",
//         format: (v) => (String(v).toLowerCase() === "any" ? null : v),
//       },
//       {
//         key: "daysPerWeek",
//         label: "Days per Week",
//         format: (v) => `${v} day${Number(v) > 1 ? "s" : ""}/week`,
//       },
//       {
//         key: "hoursPerDay",
//         label: "Hours per Day",
//         format: (v) => `${v} hour${Number(v) > 1 ? "s" : ""}/day`,
//       },
//       { key: "priorityInstitution", label: "Priority Institution" },
//       { key: "salary", label: "Salary", format: (v) => `৳${v}` },
//     ],
//   };

//   const fields = serviceFields[serviceName] || [];
//   const svcPricing = SERVICE_PRICING[serviceName];
//   const bookingFee =
//     serviceName === "Tutor Service" ? 0 : (svcPricing?.base ?? 0);
//   const isTutor = serviceName === "Tutor Service";

//   /* ----------------------------- build line items ----------------------------- */
//   const lines = fields
//     .map(({ key, label, format }) => {
//       const raw = order?.[key];
//       if (raw === undefined || raw === null) return null;

//       const formatted = format ? format(raw) : raw;

//       // ---------- AC (tier logic + numeric checkup) ----------
//       if (serviceName === "AC Service") {
//         // descriptors
//         if (["acType", "acTon", "remarks"].includes(key) && isTruthy(formatted)) {
//           return { key, label, descriptor: true, descriptorValue: formatted };
//         }

//         // numeric per-unit (tiered)
//         if (
//           [
//             "installation_outdoor_inside",
//             "installation_outdoor_outside",
//             "uninstallation_outdoor_inside",
//             "uninstallation_outdoor_outside",
//             "cleaning_outdoor_inside",
//             "cleaning_outdoor_outside",
//           ].includes(key)
//         ) {
//           const qty = Number(raw || 0);
//           if (qty <= 0) return null;
//           const { total, text } = acPerUnitCost(key, qty); // uses corrected rule
//           return {
//             key,
//             label,
//             qty,
//             lineTotal: total,
//             priceText: text, // e.g., "2 × 1100"
//             descriptor: false,
//           };
//         }

//         // numeric AC checkup
//         if (key === "issue_checkup") {
//           const qty = Number(raw || 0);
//           if (qty <= 0) return null;
//           const { total, text } = acCheckupCost(qty);
//           return {
//             key,
//             label,
//             qty,
//             lineTotal: total,
//             priceText: text, // e.g., "2 — 500 + 1 × 200"
//             descriptor: false,
//           };
//         }

//         // anything else in AC is descriptor-only
//         if (isTruthy(formatted)) {
//           return { key, label, descriptor: true, descriptorValue: formatted };
//         }
//         return null;
//       }

//       // ---------- Home Cleaning ----------
//       if (serviceName === "Home Cleaning") {
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;

//         // first-free group
//         const ffKey = MAP_HOME_FIRSTFREE[key];
//         if (ffKey && svcPricing?.firstFree?.[ffKey]) {
//           const perAdditional = svcPricing.firstFree[ffKey].perAdditional || 0;
//           const chargeable = Math.max(0, qty - 1);
//           if (chargeable <= 0) {
//             return {
//               key,
//               label,
//               qty,
//               unitPrice: perAdditional,
//               lineTotal: 0,
//               priceText: `0 × ${perAdditional} (1st included)`,
//               descriptor: false,
//             };
//           }
//           return {
//             key,
//             label,
//             qty: chargeable,
//             unitPrice: perAdditional,
//             lineTotal: chargeable * perAdditional,
//             priceText: `${chargeable} × ${perAdditional} (1st included)`,
//             descriptor: false,
//           };
//         }

//         // straight per-unit
//         const puKey = MAP_HOME_PERUNIT[key];
//         const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
//         if (rate && qty > 0) {
//           return {
//             key,
//             label,
//             qty,
//             unitPrice: rate,
//             lineTotal: qty * rate,
//             priceText: `${qty} × ${rate}`,
//             descriptor: false,
//           };
//         }
//         return null;
//       }

//       // ---------- Electrician ----------
//       if (serviceName === "Electrician") {
//           // boolean flat (checkup)
//           if (typeof raw === "boolean") {
//             if (!raw) return null;
//             const flatKey = ELEC_BOOL_FLAT[key];
//             const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//             if (!flat) return null;
//             return {
//               key,
//               label,
//               qty: 1,
//               unitPrice: flat,
//               lineTotal: flat,
//               priceText: `1 × ${flat}`,
//               descriptor: false,
//             };
//           }

//           const qty = Number(raw || 0);
//           if (qty <= 0) return null;

//           const rate = svcPricing?.perUnit?.[key];

//           // normal per-unit: number
//           if (typeof rate === "number") {
//             if (!Number.isFinite(rate) || rate <= 0) return null;
//             return {
//               key,
//               label,
//               qty,
//               unitPrice: rate,
//               lineTotal: qty * rate,
//               priceText: `${qty} × ${rate}`,
//               descriptor: false,
//             };
//           }

//           // drill-hole style pricing: { first, additional }
//           if (rate && typeof rate === "object") {
//             const first = Number(rate.first ?? 0);
//             const additional = Number(rate.additional ?? rate.first ?? 0);
//             if (!first && !additional) return null;

//             const total = first + Math.max(0, qty - 1) * additional;

//             const text =
//               qty === 1
//                 ? `1 × ${first}`
//                 : `1 × ${first} + (${qty - 1} × ${additional})`;

//             return {
//               key,
//               label,
//               qty,
//               unitPrice: first,          
//               lineTotal: total,
//               priceText: text,
//               descriptor: false,
//             };
//           }

//           return null;
//         }

//       // ---------- Plumber ----------
//       if (serviceName === "Plumber") {
//         if (typeof raw === "boolean") {
//           if (!raw) return null;
//           const flatKey = PLUMBER_BOOL_FLAT[key];
//           const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//           if (!flat) return null;
//           return {
//             key,
//             label,
//             qty: 1,
//             unitPrice: flat,
//             lineTotal: flat,
//             priceText: `1 × ${flat}`,
//             descriptor: false,
//           };
//         }
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         const pKey = MAP_PLUMBER[key];
//         const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
//         if (!rate) return null;
//         return {
//           key,
//           label,
//           qty,
//           unitPrice: rate,
//           lineTotal: qty * rate,
//           priceText: `${qty} × ${rate}`,
//           descriptor: false,
//         };
//       }

//       // ---------- Gas Chula ----------
//       if (serviceName === "Gas Chula") {
//         if (typeof raw === "boolean") {
//           if (!raw) return null;
//           const flatKey = GAS_BOOL_FLAT[key];
//           const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//           if (!flat) return null;
//           return {
//             key,
//             label,
//             qty: 1,
//             unitPrice: flat,
//             lineTotal: flat,
//             priceText: `1 × ${flat}`,
//             descriptor: false,
//           };
//         }
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         const pKey = MAP_GAS[key];
//         const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
//         if (!rate) return null;
//         return {
//           key,
//           label,
//           qty,
//           unitPrice: rate,
//           lineTotal: qty * rate,
//           priceText: `${qty} × ${rate}`,
//           descriptor: false,
//         };
//       }

//       // ---------- Filter ----------
//       if (serviceName === "Filter") {
//         if (typeof raw === "boolean") {
//           if (!raw) return null;
//           const flatKey = FILTER_BOOL_FLAT[key];
//           const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//           if (!flat) return null;
//           return {
//             key,
//             label,
//             qty: 1,
//             unitPrice: flat,
//             lineTotal: flat,
//             priceText: `1 × ${flat}`,
//             descriptor: false,
//           };
//         }
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         const pKey = MAP_FILTER[key];
//         const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
//         if (!rate) return null;
//         return {
//           key,
//           label,
//           qty,
//           unitPrice: rate,
//           lineTotal: qty * rate,
//           priceText: `${qty} × ${rate}`,
//           descriptor: false,
//         };
//       }

//       // ---------- Tutor / Others: descriptors only ----------
//       if (isTruthy(formatted)) {
//         return { key, label, descriptor: true, descriptorValue: formatted };
//       }
//       return null;
//     })
//     .filter(Boolean);

//   const subTotal = lines
//     .filter((l) => !l.descriptor)
//     .reduce((acc, l) => acc + l.lineTotal, 0);

//   const discount =
//     serviceName === "Tutor Service"
//       ? 0
//       : Math.max(0, Number(order?.discountValue || 0));

//   const extraCharge = !isTutor
//     ? Math.max(0, Number(order?.extraCharge || 0))
//     : 0;

//   const baseTotal =
//     serviceName === "Tutor Service"
//       ? order?.price ?? subTotal
//       : subTotal + bookingFee;

//   const computedFinal = Math.max(0, baseTotal - discount + extraCharge);
  
//   // const grandTotal = Math.max(0, baseTotal - discount);
//   const grandTotal = Number.isFinite(Number(order?.price))
//     ? Number(order.price)
//     : computedFinal;

//   // 4-column grid chunk
//   const chunkedServices = [];
//   for (let i = 0; i < lines.length; i += 4) {
//     chunkedServices.push(lines.slice(i, i + 4));
//   }

//   return (
//     <div className="ServitorReceipt-container" ref={ref}>
//       {/* HEADER */}
//       <div className="ServitorReceipt-header">
//         <div className="ServitorReceipt-header-top">
//           {/* <div className="ServitorReceipt-logo">HelpNao</div> */}

//           <div className="ServitorReceipt-brand">
//             <div className="ServitorReceipt-logo-circle">
//               <img
//                 src={HelpNaoLogo}
//                 alt="HelpNao logo"
//                 className="ServitorReceipt-logo-img"
//               />
//             </div>
//             <div className="ServitorReceipt-brand-text">HelpNao</div>
//           </div>

//           <div className="ServitorReceipt-number">
//             <h3>Servitor Receipt</h3>
//             <p>Order #{order.order_number}</p>
//           </div>
//         </div>

//         <div className="ServitorReceipt-order-info">
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Order Date</span>
//             <span className="ServitorReceipt-value">
//               {new Date(order.created_at).toLocaleDateString("en-US", {
//                 month: "long",
//                 day: "numeric",
//                 year: "numeric",
//               })}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Date</span>
//             <span className="ServitorReceipt-value">
//               {order.date
//                 ? new Date(order.date).toLocaleDateString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })
//                 : "TBD"}
//             </span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Service Time</span>
//             <span className="ServitorReceipt-value">{order.time}</span>
//           </div>
//           <div className="ServitorReceipt-item">
//             <span className="ServitorReceipt-label">Status</span>
//             <span className="ServitorReceipt-status-badge">{order.status}</span>
//           </div>
//         </div>
//       </div>

//       <div className="ServitorReceipt-content">
//         {/* Service Details */}
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Service Details</h2>
//           <div className="ServitorReceipt-details-row">
//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Customer Information</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.User
//                     ? `${order.User.FirstName} ${order.User.LastName}`
//                     : "Unknown"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Location</span>
//                 <span className="ServitorReceipt-value">
//                   {(order.usercity || order.City) ?? "N/A"}
//                   {order.userarea || order.Area
//                     ? `, ${order.userarea || order.Area}`
//                     : ""}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.useraddress || order.Address || "N/A"}
//                 </span>
//               </div>
//             </div>

//             <div className="ServitorReceipt-block">
//               <h3 className="ServitorReceipt-block-title">Service Provider</h3>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Name</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor
//                     ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
//                     : "N/A"}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Location</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.city || "N/A" : "N/A"}
//                   {order.Servitor && order.Servitor.area
//                     ? `, ${order.Servitor.area}`
//                     : ""}
//                 </span>
//               </div>
//               <div className="ServitorReceipt-row">
//                 <span className="ServitorReceipt-label">Address</span>
//                 <span className="ServitorReceipt-value">
//                   {order.Servitor ? order.Servitor.Address || "No Address" : "N/A"}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Services Provided */}
//         <div className="ServitorReceipt-section">
//           <h2 className="ServitorReceipt-title">Services Provided</h2>
//           <div className="ServitorReceipt-service-section">
//             <div className="ServitorReceipt-service-header">{serviceName}</div>
//             <div className="ServitorReceipt-service-table">
//               {(() => {
//                 if (lines.length === 0) {
//                   return (
//                     <div className="ServitorReceipt-service-row">
//                       <div className="ServitorReceipt-service-card">
//                         <div className="ServitorReceipt-service-name">
//                           No billable items.
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 }
//                 return chunkedServices.map((row, rowIdx) => (
//                   <div className="ServitorReceipt-service-row" key={rowIdx}>
//                     {row.map((svc, idx) => (
//                       <div className="ServitorReceipt-service-card" key={idx}>
//                         <div className="ServitorReceipt-service-name">{svc.label}</div>

//                         {"descriptor" in svc && svc.descriptor ? (
//                           <div className="ServitorReceipt-service-descriptor">
//                             {String(svc.descriptorValue)}
//                           </div>
//                         ) : (
//                           <div className="ServitorReceipt-service-quantity">
//                             {svc.priceText} = <strong>{money(svc.lineTotal)}</strong>
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                     {Array.from({ length: 4 - row.length }).map((_, idx) => (
//                       <div
//                         key={`empty-${idx}`}
//                         className="ServitorReceipt-service-card-empty"
//                       />
//                     ))}
//                   </div>
//                 ));
//               })()}
//             </div>
//           </div>
//         </div>

//         {/* Subtotal + Booking Fee + Discount (except Tutor) */}
//         {!isTutor && (
//           <div className="ServitorReceipt-subtotals">
//             <div className="ServitorReceipt-totals-row">
//               <span className="ServitorReceipt-total-label">Subtotal</span>
//               <span className="ServitorReceipt-total-value">{money(subTotal)}</span>
//             </div>
//             <div className="ServitorReceipt-totals-row">
//               {/* <span className="ServitorReceipt-total-label">Booking Fee</span> */}
//               <span className="ServitorReceipt-total-label">Platform & Support Fee</span>
//               <span className="ServitorReceipt-total-value">{money(bookingFee)}</span>
//             </div>
//             {Number(discount) > 0 && (
//               <div className="ServitorReceipt-totals-row">
//                 <span className="ServitorReceipt-total-label">Discount</span>
//                 <span className="ServitorReceipt-total-value">
//                   −{money(discount)}
//                 </span>
//               </div>
//             )}

//             {Number(extraCharge) > 0 && (
//               <div className="ServitorReceipt-totals-row">
//                 <span className="ServitorReceipt-total-label">
//                   Extra Service Charge
//                 </span>
//                 <span className="ServitorReceipt-total-value">
//                   +{money(extraCharge)}
//                 </span>
//               </div>
//             )}
            
//           </div>
//         )}

//         {/* Final Total */}
//         <div className="ServitorReceipt-total-section">
//           <div className="ServitorReceipt-total-label">Total Amount</div>
//           <div className="ServitorReceipt-total-amount">{money(grandTotal)}</div>
//         </div>
//       </div>

//       {/* FOOTER */}
//       <div className="ServitorReceipt-footer">
//         <div className="ServitorReceipt-footer-title">
//           Thank you for serving with HelpNao!
//         </div>
//         <div className="ServitorReceipt-footer-text">
//           Your dedication drives our success
//         </div>
//         <div className="ServitorReceipt-contact-info">
//           For support: helpnao.com@gmail.com | +8801779256378
//         </div>
//       </div>
//     </div>
//   );
// });

// export default ServitorInvoiceTemplate;






// ***** Update with Custom Service orders - (6-January-2026) ***** //
import React, { forwardRef } from "react";
import "./ServitorInvoiceTemplate.css";
import HelpNaoLogo from "../../../Assets/HelpNaoLogo.png";

import {
  SERVICE_PRICING,
  AC_PRICING,
} from "../../Services/servicePricing";

/* ----------------------------- mappings -> pricing keys ----------------------------- */
// Electrician
// const MAP_ELECTRICIAN = {
//   ceiling_fan_installation:       "ceilingFanInstallation",
//   ceiling_fan_uninstallation:     "ceilingFanUninstallation",
//   fan_coil_new_winding:           "fanCoilNewWinding",
//   fan_coil_repair:                "fanCoilRepair",
//   capacitor_setup:                "capacitorSetup",
//   light_installation:             "lightInstallation",
//   light_repair:                   "lightRepair",
//   exhaust_fan_installation:       "exhaustFanInstallation",
//   exhaust_fan_cleaning:           "exhaustFanCleaning",
//   switch_setup:                   "switchSetup",
//   socket_setup:                   "socketSetup",
//   regulator_setup:                "regulatorSetup",
//   new_wiring_point:               "newWiringPoint",
//   main_circuit_board_setup:       "mainCircuitBoardSetup",
//   doorbell_installation:          "doorbellInstallation",
//   drill_hole_service:             "drillHoleService",
//   ips_installation_existing_line: "ipsInstallationExistingLine",
//   ips_new_line_installation:      "ipsNewLineInstallation",
// };
const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };

// Plumber
const MAP_PLUMBER = {
  angle_valve_setup:                       "angleValveSetup",
  basin_tap_setup:                         "basinTapSetup",
  magic_pipe_setup:                        "magicPipeSetup",
  basin_waste_pop_up_setup:                "basinWastePopUpSetup",
  new_basin_setup_existing_lines:          "newBasinSetupExistingLines",

  bathroom_tap_bib_cock_setup:             "bathroomTapBibCockSetup",
  tissue_holder_setup:                     "tissueHolderSetup",
  fill_valve_replacement:                  "fillValveReplacement",
  hand_shower_setup:                       "handShowerSetup",
  soap_dish_setup:                         "soapDishSetup",
  bathroom_shelf_setup:                    "bathroomShelfSetup",
  mirror_setup:                            "mirrorSetup",
  towel_hanger_setup:                      "towelHangerSetup",
  shower_head_setup:                       "showerHeadSetup",
  concealed_stopcock_setup:                "concealedStopcockSetup",
  floor_drain_net_setup:                   "floorDrainNetSetup",

  toilet_seat_cover_replacement:           "toiletSeatCoverReplacement",
  toilet_seat_complete_installation:       "toiletSeatCompleteInstallation",
  high_commode_installation_existing_lines:"highCommodeInstallationExistingLines",
  blockage_clearing_high_commode:          "blockageClearingHighCommode",
  blockage_clearing_low_commode:           "blockageClearingLowCommode",

  bathroom_drain_line_cleaning:            "bathroomDrainLineCleaning",
  geyser_installation:                     "geyserInstallation",

  kitchen_sink_setup_existing_lines:       "kitchenSinkSetupExistingLines",
  sink_blockage_cleaning:                  "sinkBlockageCleaning",
  washing_machine_point_setup:             "washingMachinePointSetup",
};
const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };

// Gas Chula
const MAP_GAS = {
  NewchulaSetup: "newChulaSetup",
  chulaSetup: "chulaSetup",
  burnerSetup: "burnerSetup",
  burnerCleaning: "burnerCleaning",
  nozzleReplacement: "nozzleReplacement",
};
const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };

// Filter
const MAP_FILTER = {
  new_filter_setup: "newFilterSetup",
  installation_filter: "installationFilter",
  uninstallation_filter: "uninstallationFilter",
  kit_replacement: "kitReplacement",
  pipe_leak_or_replace: "pipeLeakOrReplace",
  full_servicing: "fullServicing",
};
const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };

// Home Cleaning
const MAP_HOME_FIRSTFREE = {
  bed: "bedrooms",
  kitchen: "kitchens",
  dra_din: "drawingdinning",
};
const MAP_HOME_PERUNIT = {
  bath: "bathrooms",
  cloth: "cloths",
  dish: "dishes",
  balcony: "balconies",
  window_grill: "windowGrills",
  furniture_cleaning: "furniture",
  stairs_and_railing: "stairsFloors",
  carpet_cleaning: "carpets",
};

/* ----------------------------- utils ----------------------------- */
const isTruthy = (v) =>
  (typeof v === "number" && v > 0) ||
  (typeof v === "boolean" && v) ||
  (typeof v === "string" &&
    v.trim() &&
    !["no", "n/a", "any"].includes(v.trim().toLowerCase()));

  const money = (n) => `৳${Number(n || 0).toLocaleString("en-BD")}`;

  // Custom services helper (supports backend parsed customServices OR parses custom_service_json)
  const getCustomItems = (order) => {
    if (Array.isArray(order?.customServices)) return order.customServices;

    const raw = order?.custom_service_json;
    if (!raw) return [];

    try {
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

/* ----------------------------- AC helpers (correct tier logic) ----------------------------- */
// Rule: 1 unit => use `first`; 2+ units => ALL units billed at `additional`
const acPerUnitCost = (prop, qty) => {
  const c = Math.max(0, Number(qty) || 0);
  if (!c) return { total: 0, text: "" };

  const rate = AC_PRICING?.perUnit?.[prop];
  if (!rate) return { total: 0, text: "" };

  if (c === 1) {
    return { total: rate.first, text: `1 × ${rate.first}` };
  }
  const total = c * rate.additional;
  return { total, text: `${c} × ${rate.additional}` };
};

// Checkup: base covers up to `includesUnits`, extras charged per AC above that
const acCheckupCost = (qty) => {
  const c = Math.max(0, Number(qty) || 0);
  if (!c) return { total: 0, text: "" };

  const { base = 0, includesUnits = 0, extraPerUnit = 0 } =
    AC_PRICING.checkup || {};

  if (c <= includesUnits) {
    return {
      total: base,
      text: `${c} unit${c > 1 ? "s" : ""} — ${base}`,
    };
  }
  const over = c - includesUnits;
  const total = base + over * extraPerUnit;
  return {
    total,
    text: `${includesUnits} — ${base} + ${over} × ${extraPerUnit}`,
  };
};

const ServitorInvoiceTemplate = forwardRef(({ order }, ref) => {
  const serviceName =
    order?.Service?.services_name || order?.service_name || "Unknown";

  /* ===================== visible fields for invoice ===================== */
  const serviceFields = {
    "Home Cleaning": [
      { key: "bed", label: "Bedroom" },
      { key: "kitchen", label: "Kitchen" },
      { key: "dra_din", label: "Drawing-Dining" },
      { key: "bath", label: "Bathroom" },
      { key: "balcony", label: "Balcony Cleaning" },
      { key: "window_grill", label: "Window & Grill Cleaning" },
      { key: "stairs_and_railing", label: "Stairs & Railing Cleaning" },
      { key: "furniture_cleaning", label: "Furniture Cleaning" },
      { key: "cloth", label: "Cloths" },
      { key: "dish", label: "Dishes" },
      { key: "carpet_cleaning", label: "Carpet Cleaning" },
    ],
    Electrician: [
      
      { key: "new_ceiling_fan_installation",   label: "New Ceiling Fan Installation" },
      { key: "ceiling_fan_installation",       label: "Ceiling Fan Installation" },
      { key: "ceiling_fan_uninstallation",     label: "Ceiling Fan Uninstallation" },
      { key: "fan_coil_new_winding",           label: "Fan Coil New Winding" },
      { key: "fan_coil_repair",                label: "Fan Coil Repair" },
      { key: "capacitor_setup",                label: "Capacitor Setup" },
      { key: "light_installation",             label: "Light Installation" },
      { key: "light_repair",                   label: "Light Repair" },
      { key: "exhaust_fan_installation",       label: "Exhaust Fan Installation" },
      { key: "exhaust_fan_cleaning",           label: "Exhaust Fan Cleaning" },
      { key: "switch_setup",                   label: "Switch setup" },
      { key: "socket_setup",                   label: "Socket setup" },
      { key: "regulator_setup",                label: "Regulator setup" },
      { key: "new_wiring_point",               label: "New Wiring Point" },
      { key: "main_circuit_board_setup",       label: "Setup Main Circuit board" },
      { key: "doorbell_installation",          label: "setup Doorbell Installation" },
      { key: "drill_hole_service",             label: "Drill Hole Service" },
      { key: "ips_installation_existing_line", label: "IPS Installation (Existing Line)" },
      { key: "ips_new_line_installation",      label: "IPS Installation (New Line)" },
      { key: "Electrical_checkup",             label: "Electrical Checkup", format: v => (v ? "Yes" : "No") },
    ],
    Plumber: [
      
      // Basin & Kitchen
      { key: "angle_valve_setup",              label: "Angle Valve Setup" },
      { key: "basin_tap_setup",                label: "Basin Tap (Faucet) Setup" },
      { key: "magic_pipe_setup",               label: "Magic Pipe (Flexible Drain) Setup" },
      { key: "basin_waste_pop_up_setup",       label: "Basin Waste / Pop-Up Setup" },
      { key: "new_basin_setup_existing_lines", label: "New Basin Setup (existing lines)" },
      { key: "kitchen_sink_setup_existing_lines", label: "Kitchen Sink Setup (existing lines)" },
      { key: "sink_blockage_cleaning",         label: "Sink Blockage Cleaning (1 sink line)" },

      // Bathroom fittings
      { key: "bathroom_tap_bib_cock_setup",    label: "Bathroom Tap Setup" },
      { key: "tissue_holder_setup",            label: "Tissue Holder Setup" },
      { key: "fill_valve_replacement",         label: "High Commode Ball Cock Replacement" },
      { key: "hand_shower_setup",              label: "Hand Shower Setup" },
      { key: "soap_dish_setup",                label: "Soap Stand Setup" },
      { key: "bathroom_shelf_setup",           label: "Bathroom Shelf Setup" },
      { key: "mirror_setup",                   label: "Looking Glass/Mirror Setup" },
      { key: "towel_hanger_setup",             label: "Towel Hanger Setup" },
      { key: "shower_head_setup",              label: "Shower Head Setup" },
      { key: "concealed_stopcock_setup",       label: "Concealed Stopcock Valve Setup" },
      { key: "floor_drain_net_setup",          label: "Floor Drain Net Setup" },

      // Commode
      { key: "toilet_seat_cover_replacement",  label: "Toilet Seat Cover Replacement (Standard)" },
      { key: "toilet_seat_complete_installation", label: "Toilet Seat Complete Set Installation" },
      { key: "high_commode_installation_existing_lines", label: "High Commode Toilet Installation (existing lines)" },
      { key: "blockage_clearing_high_commode", label: "Blockage Clearing — High Commode" },
      { key: "blockage_clearing_low_commode",  label: "Blockage Clearing — Low Commode" },

      // Cleaning / heavy
      { key: "bathroom_drain_line_cleaning",   label: "Bathroom Drain Line Cleaning (per bathroom)" },

      // Geyser & points
      { key: "geyser_installation",            label: "Geyser Installation (existing lines & power)" },
      { key: "washing_machine_point_setup",    label: "Washing Machine Point Setup (existing lines)" },
      {
        key: "issue_checkup",
        label: "Issue Checkup",
        format: (v) => (v ? "Yes" : "No"),
      },
    ],
    "Gas Chula": [
      { key: "chulaCylinderType", label: "Cylinder Type" },
      { key: "NewchulaSetup", label: "New Chula Setup" },
      { key: "chulaSetup", label: "Chula Setup" },
      { key: "burnerSetup", label: "Burner Setup" },
      { key: "burnerCleaning", label: "Burner Cleaning" },
      { key: "nozzleReplacement", label: "Nozzle Replacement" },
      {
        key: "checkIssues",
        label: "Check Issues",
        format: (v) => (v ? "Yes" : "No"),
      },
    ],
    //  UPDATED AC FIELDS
    "AC Service": [
      { key: "acType", label: "AC Type" },
      { key: "acTon", label: "AC Ton" },

      { key: "installation_outdoor_inside", label: "Installation (Outdoor Inside)" },
      { key: "installation_outdoor_outside", label: "Installation (Outdoor Outside)" },

      { key: "uninstallation_outdoor_inside", label: "Uninstallation (Outdoor Inside)" },
      { key: "uninstallation_outdoor_outside", label: "Uninstallation (Outdoor Outside)" },

      { key: "cleaning_outdoor_inside", label: "Cleaning (Outdoor Inside)" },
      { key: "cleaning_outdoor_outside", label: "Cleaning (Outdoor Outside)" },

      { key: "issue_checkup", label: "AC Checkup (No. of AC)" }, // numeric
      { key: "remarks", label: "Remarks" },
    ],
    Filter: [
      { key: "filter_type", label: "Filter Type" },
      { key: "new_filter_setup", label: "New Filter Setup" },
      { key: "installation_filter", label: "Filter Installation" },
      { key: "uninstallation_filter", label: "Filter Uninstallation" },
      { key: "kit_replacement", label: "Kit Replacement" },
      { key: "pipe_leak_or_replace", label: "Pipe Leak / Replace" },
      { key: "full_servicing", label: "Full Servicing" },
      {
        key: "check_up",
        label: "Issue Checkup",
        format: (v) => (v ? "Yes" : "No"),
      },
    ],
    "Tutor Service": [
      { key: "subject", label: "Subject" },
      { key: "classLevel", label: "Class/Level" },
      { key: "medium", label: "Medium" },
      {
        key: "preferredTutorGender",
        label: "Preferred Tutor Gender",
        format: (v) => (String(v).toLowerCase() === "any" ? null : v),
      },
      {
        key: "daysPerWeek",
        label: "Days per Week",
        format: (v) => `${v} day${Number(v) > 1 ? "s" : ""}/week`,
      },
      {
        key: "hoursPerDay",
        label: "Hours per Day",
        format: (v) => `${v} hour${Number(v) > 1 ? "s" : ""}/day`,
      },
      { key: "priorityInstitution", label: "Priority Institution" },
      { key: "salary", label: "Salary", format: (v) => `৳${v}` },
    ],
  };

  const fields = serviceFields[serviceName] || [];
  const svcPricing = SERVICE_PRICING[serviceName];
  // const bookingFee =
  //   serviceName === "Tutor Service" ? 0 : (svcPricing?.base ?? 0);
  const isTutor = serviceName === "Tutor Service";


  const platformPercent = svcPricing?.platformFee?.percent ?? 0.05;
  const platformMin = svcPricing?.platformFee?.min ?? 50;

  /* ----------------------------- build line items ----------------------------- */
  const baseLines = fields
    .map(({ key, label, format }) => {
      const raw = order?.[key];
      if (raw === undefined || raw === null) return null;

      const formatted = format ? format(raw) : raw;

      // ---------- AC (tier logic + numeric checkup) ----------
      if (serviceName === "AC Service") {
        // descriptors
        if (["acType", "acTon", "remarks"].includes(key) && isTruthy(formatted)) {
          return { key, label, descriptor: true, descriptorValue: formatted };
        }

        // numeric per-unit (tiered)
        if (
          [
            "installation_outdoor_inside",
            "installation_outdoor_outside",
            "uninstallation_outdoor_inside",
            "uninstallation_outdoor_outside",
            "cleaning_outdoor_inside",
            "cleaning_outdoor_outside",
          ].includes(key)
        ) {
          const qty = Number(raw || 0);
          if (qty <= 0) return null;
          const { total, text } = acPerUnitCost(key, qty); // uses corrected rule
          return {
            key,
            label,
            qty,
            lineTotal: total,
            priceText: text, // e.g., "2 × 1100"
            descriptor: false,
          };
        }

        // numeric AC checkup
        if (key === "issue_checkup") {
          const qty = Number(raw || 0);
          if (qty <= 0) return null;
          const { total, text } = acCheckupCost(qty);
          return {
            key,
            label,
            qty,
            lineTotal: total,
            priceText: text, // e.g., "2 — 500 + 1 × 200"
            descriptor: false,
          };
        }

        // anything else in AC is descriptor-only
        if (isTruthy(formatted)) {
          return { key, label, descriptor: true, descriptorValue: formatted };
        }
        return null;
      }

      // ---------- Home Cleaning ----------
      if (serviceName === "Home Cleaning") {
        const qty = Number(raw || 0);
        if (qty <= 0) return null;

        // first-free group
        const ffKey = MAP_HOME_FIRSTFREE[key];
        if (ffKey && svcPricing?.firstFree?.[ffKey]) {
          const perAdditional = svcPricing.firstFree[ffKey].perAdditional || 0;
          const chargeable = Math.max(0, qty - 1);
          if (chargeable <= 0) {
            return {
              key,
              label,
              qty,
              unitPrice: perAdditional,
              lineTotal: 0,
              priceText: `0 × ${perAdditional} (1st included)`,
              descriptor: false,
            };
          }
          return {
            key,
            label,
            qty: chargeable,
            unitPrice: perAdditional,
            lineTotal: chargeable * perAdditional,
            priceText: `${chargeable} × ${perAdditional} (1st included)`,
            descriptor: false,
          };
        }

        // straight per-unit
        const puKey = MAP_HOME_PERUNIT[key];
        const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
        if (rate && qty > 0) {
          return {
            key,
            label,
            qty,
            unitPrice: rate,
            lineTotal: qty * rate,
            priceText: `${qty} × ${rate}`,
            descriptor: false,
          };
        }
        return null;
      }

      // ---------- Electrician ----------
      if (serviceName === "Electrician") {
          // boolean flat (checkup)
          if (typeof raw === "boolean") {
            if (!raw) return null;
            const flatKey = ELEC_BOOL_FLAT[key];
            const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
            if (!flat) return null;
            return {
              key,
              label,
              qty: 1,
              unitPrice: flat,
              lineTotal: flat,
              priceText: `1 × ${flat}`,
              descriptor: false,
            };
          }

          const qty = Number(raw || 0);
          if (qty <= 0) return null;

          const rate = svcPricing?.perUnit?.[key];

          // normal per-unit: number
          if (typeof rate === "number") {
            if (!Number.isFinite(rate) || rate <= 0) return null;
            return {
              key,
              label,
              qty,
              unitPrice: rate,
              lineTotal: qty * rate,
              priceText: `${qty} × ${rate}`,
              descriptor: false,
            };
          }

          // drill-hole style pricing: { first, additional }
          if (rate && typeof rate === "object") {
            const first = Number(rate.first ?? 0);
            const additional = Number(rate.additional ?? rate.first ?? 0);
            if (!first && !additional) return null;

            const total = first + Math.max(0, qty - 1) * additional;

            const text =
              qty === 1
                ? `1 × ${first}`
                : `1 × ${first} + (${qty - 1} × ${additional})`;

            return {
              key,
              label,
              qty,
              unitPrice: first,          
              lineTotal: total,
              priceText: text,
              descriptor: false,
            };
          }

          return null;
        }

      // ---------- Plumber ----------
      if (serviceName === "Plumber") {
        if (typeof raw === "boolean") {
          if (!raw) return null;
          const flatKey = PLUMBER_BOOL_FLAT[key];
          const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
          if (!flat) return null;
          return {
            key,
            label,
            qty: 1,
            unitPrice: flat,
            lineTotal: flat,
            priceText: `1 × ${flat}`,
            descriptor: false,
          };
        }
        const qty = Number(raw || 0);
        if (qty <= 0) return null;
        const pKey = MAP_PLUMBER[key];
        const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
        if (!rate) return null;
        return {
          key,
          label,
          qty,
          unitPrice: rate,
          lineTotal: qty * rate,
          priceText: `${qty} × ${rate}`,
          descriptor: false,
        };
      }

      // ---------- Gas Chula ----------
      if (serviceName === "Gas Chula") {
        if (typeof raw === "boolean") {
          if (!raw) return null;
          const flatKey = GAS_BOOL_FLAT[key];
          const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
          if (!flat) return null;
          return {
            key,
            label,
            qty: 1,
            unitPrice: flat,
            lineTotal: flat,
            priceText: `1 × ${flat}`,
            descriptor: false,
          };
        }
        const qty = Number(raw || 0);
        if (qty <= 0) return null;
        const pKey = MAP_GAS[key];
        const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
        if (!rate) return null;
        return {
          key,
          label,
          qty,
          unitPrice: rate,
          lineTotal: qty * rate,
          priceText: `${qty} × ${rate}`,
          descriptor: false,
        };
      }

      // ---------- Filter ----------
      if (serviceName === "Filter") {
        if (typeof raw === "boolean") {
          if (!raw) return null;
          const flatKey = FILTER_BOOL_FLAT[key];
          const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
          if (!flat) return null;
          return {
            key,
            label,
            qty: 1,
            unitPrice: flat,
            lineTotal: flat,
            priceText: `1 × ${flat}`,
            descriptor: false,
          };
        }
        const qty = Number(raw || 0);
        if (qty <= 0) return null;
        const pKey = MAP_FILTER[key];
        const rate = pKey ? svcPricing?.perUnit?.[pKey] || 0 : 0;
        if (!rate) return null;
        return {
          key,
          label,
          qty,
          unitPrice: rate,
          lineTotal: qty * rate,
          priceText: `${qty} × ${rate}`,
          descriptor: false,
        };
      }

      // ---------- Tutor / Others: descriptors only ----------
      if (isTruthy(formatted)) {
        return { key, label, descriptor: true, descriptorValue: formatted };
      }
      return null;
    })
    .filter(Boolean);

    //  Custom service orders
const customLines = getCustomItems(order)
  .map((c, idx) => {
    const name = String(c?.name || "").trim();
    const price = Number(c?.price || 0);

    if (!name) return null;
    if (!Number.isFinite(price) || price <= 0) return null;

    return {
      key: `custom_${idx}`,
      label: `Custom Service: ${name}`,
      qty: 1,
      unitPrice: price,
      lineTotal: price,
      priceText: `1 × ${price}`,
      descriptor: false,
    };
  })
  .filter(Boolean);

//  final lines used everywhere
const lines = [...baseLines, ...customLines];

  const subTotal = lines
    .filter((l) => !l.descriptor)
    .reduce((acc, l) => acc + l.lineTotal, 0);

  const platformFee = isTutor
  ? 0
  : Math.max(platformMin, Math.round(subTotal * platformPercent));

  
  const discount =
    serviceName === "Tutor Service"
      ? 0
      : Math.max(0, Number(order?.discountValue || 0));

  const extraCharge = !isTutor
    ? Math.max(0, Number(order?.extraCharge || 0))
    : 0;

  const baseTotal =
    serviceName === "Tutor Service"
      ? order?.price ?? subTotal
      : subTotal + platformFee;

  const computedFinal = Math.max(0, baseTotal - discount + extraCharge);
  
  // const grandTotal = Math.max(0, baseTotal - discount);
  const grandTotal = Number.isFinite(Number(order?.price))
    ? Number(order.price)
    : computedFinal;

  // 4-column grid chunk
  const chunkedServices = [];
  for (let i = 0; i < lines.length; i += 4) {
    chunkedServices.push(lines.slice(i, i + 4));
  }

  return (
    <div className="ServitorReceipt-container" ref={ref}>
      {/* HEADER */}
      <div className="ServitorReceipt-header">
        <div className="ServitorReceipt-header-top">
          {/* <div className="ServitorReceipt-logo">HelpNao</div> */}

          <div className="ServitorReceipt-brand">
            <div className="ServitorReceipt-logo-circle">
              <img
                src={HelpNaoLogo}
                alt="HelpNao logo"
                className="ServitorReceipt-logo-img"
              />
            </div>
            <div className="ServitorReceipt-brand-text">HelpNao</div>
          </div>

          <div className="ServitorReceipt-number">
            <h3>Servitor Receipt</h3>
            <p>Order #{order.order_number}</p>
          </div>
        </div>

        <div className="ServitorReceipt-order-info">
          <div className="ServitorReceipt-item">
            <span className="ServitorReceipt-label">Order Date</span>
            <span className="ServitorReceipt-value">
              {new Date(order.created_at).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })}
            </span>
          </div>
          <div className="ServitorReceipt-item">
            <span className="ServitorReceipt-label">Service Date</span>
            <span className="ServitorReceipt-value">
              {order.date
                ? new Date(order.date).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })
                : "TBD"}
            </span>
          </div>
          <div className="ServitorReceipt-item">
            <span className="ServitorReceipt-label">Service Time</span>
            <span className="ServitorReceipt-value">{order.time}</span>
          </div>
          <div className="ServitorReceipt-item">
            <span className="ServitorReceipt-label">Status</span>
            <span className="ServitorReceipt-status-badge">{order.status}</span>
          </div>
        </div>
      </div>

      <div className="ServitorReceipt-content">
        {/* Service Details */}
        <div className="ServitorReceipt-section">
          <h2 className="ServitorReceipt-title">Service Details</h2>
          <div className="ServitorReceipt-details-row">
            <div className="ServitorReceipt-block">
              <h3 className="ServitorReceipt-block-title">Customer Information</h3>
              <div className="ServitorReceipt-row">
                <span className="ServitorReceipt-label">Name</span>
                <span className="ServitorReceipt-value">
                  {order.User
                    ? `${order.User.FirstName} ${order.User.LastName}`
                    : "Unknown"}
                </span>
              </div>
              <div className="ServitorReceipt-row">
                <span className="ServitorReceipt-label">Location</span>
                <span className="ServitorReceipt-value">
                  {(order.usercity || order.City) ?? "N/A"}
                  {order.userarea || order.Area
                    ? `, ${order.userarea || order.Area}`
                    : ""}
                </span>
              </div>
              <div className="ServitorReceipt-row">
                <span className="ServitorReceipt-label">Address</span>
                <span className="ServitorReceipt-value">
                  {order.useraddress || order.Address || "N/A"}
                </span>
              </div>
            </div>

            <div className="ServitorReceipt-block">
              <h3 className="ServitorReceipt-block-title">Service Provider</h3>
              <div className="ServitorReceipt-row">
                <span className="ServitorReceipt-label">Name</span>
                <span className="ServitorReceipt-value">
                  {order.Servitor
                    ? `${order.Servitor.FirstName} ${order.Servitor.LastName}`
                    : "N/A"}
                </span>
              </div>
              <div className="ServitorReceipt-row">
                <span className="ServitorReceipt-label">Location</span>
                <span className="ServitorReceipt-value">
                  {order.Servitor ? order.Servitor.city || "N/A" : "N/A"}
                  {order.Servitor && order.Servitor.area
                    ? `, ${order.Servitor.area}`
                    : ""}
                </span>
              </div>
              <div className="ServitorReceipt-row">
                <span className="ServitorReceipt-label">Address</span>
                <span className="ServitorReceipt-value">
                  {order.Servitor ? order.Servitor.Address || "No Address" : "N/A"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Services Provided */}
        <div className="ServitorReceipt-section">
          <h2 className="ServitorReceipt-title">Services Provided</h2>
          <div className="ServitorReceipt-service-section">
            <div className="ServitorReceipt-service-header">{serviceName}</div>
            <div className="ServitorReceipt-service-table">
              {(() => {
                if (lines.length === 0) {
                  return (
                    <div className="ServitorReceipt-service-row">
                      <div className="ServitorReceipt-service-card">
                        <div className="ServitorReceipt-service-name">
                          No billable items.
                        </div>
                      </div>
                    </div>
                  );
                }
                return chunkedServices.map((row, rowIdx) => (
                  <div className="ServitorReceipt-service-row" key={rowIdx}>
                    {row.map((svc, idx) => (
                      <div className="ServitorReceipt-service-card" key={idx}>
                        <div className="ServitorReceipt-service-name">{svc.label}</div>

                        {"descriptor" in svc && svc.descriptor ? (
                          <div className="ServitorReceipt-service-descriptor">
                            {String(svc.descriptorValue)}
                          </div>
                        ) : (
                          <div className="ServitorReceipt-service-quantity">
                            {svc.priceText} = <strong>{money(svc.lineTotal)}</strong>
                          </div>
                        )}
                      </div>
                    ))}
                    {Array.from({ length: 4 - row.length }).map((_, idx) => (
                      <div
                        key={`empty-${idx}`}
                        className="ServitorReceipt-service-card-empty"
                      />
                    ))}
                  </div>
                ));
              })()}
            </div>
          </div>
        </div>

        {/* Subtotal + Booking Fee + Discount (except Tutor) */}
        {!isTutor && (
          <div className="ServitorReceipt-subtotals">
            <div className="ServitorReceipt-totals-row">
              <span className="ServitorReceipt-total-label">Subtotal</span>
              <span className="ServitorReceipt-total-value">{money(subTotal)}</span>
            </div>
            <div className="ServitorReceipt-totals-row">
              {/* <span className="ServitorReceipt-total-label">Booking Fee</span> */}
              <span className="ServitorReceipt-total-label">Platform & Support Fee</span>
              <span className="ServitorReceipt-total-value">{money(platformFee)}</span>
            </div>
            {Number(discount) > 0 && (
              <div className="ServitorReceipt-totals-row">
                <span className="ServitorReceipt-total-label">Discount</span>
                <span className="ServitorReceipt-total-value">
                  −{money(discount)}
                </span>
              </div>
            )}

            {Number(extraCharge) > 0 && (
              <div className="ServitorReceipt-totals-row">
                <span className="ServitorReceipt-total-label">
                  Extra Service Charge
                </span>
                <span className="ServitorReceipt-total-value">
                  +{money(extraCharge)}
                </span>
              </div>
            )}
            
          </div>
        )}

        {/* Final Total */}
        <div className="ServitorReceipt-total-section">
          <div className="ServitorReceipt-total-label">Total Amount</div>
          <div className="ServitorReceipt-total-amount">{money(grandTotal)}</div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="ServitorReceipt-footer">
        <div className="ServitorReceipt-footer-title">
          Thank you for serving with HelpNao!
        </div>
        <div className="ServitorReceipt-footer-text">
          Your dedication drives our success
        </div>
        <div className="ServitorReceipt-contact-info">
          For support: helpnao.com@gmail.com | +8801779256378
        </div>
      </div>
    </div>
  );
});

export default ServitorInvoiceTemplate;
